var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-5",
    d: "M77.66,275.9c-95.18,49.53-95.17,129.84,0,179.37s249.49,49.54,344.67,0,95.17-129.84,0-179.37S172.84,226.36,77.66,275.9Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "168.19 41.24 171.5 43.09 171.5 188.42 168.19 186.57 168.19 41.24",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.19 186.57 168.18 45 35.28 121.73 35.31 263.29 168.19 186.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.64,192V32.45L29.14,118.18V277.71ZM35.28,267.06V121.73L171.5,43.09V188.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.5 188.42 168.19 186.57 35.31 263.29 35.28 267.06 171.5 188.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.4 64.5 137.71 62.59 137.71 207.93 134.4 206.08 134.4 64.5",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.74 107.61 63.05 105.7 63.05 251.03 59.74 249.18 59.74 107.61",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.14 277.7 25.85 275.79 25.85 116.27 29.14 118.18 29.14 277.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.85 116.27 29.14 118.18 177.64 32.45 174.35 30.53 25.85 116.27",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.28 187.98 35.28 191.8 171.51 113.15 168.21 111.23 35.28 187.98",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "35.3 198.89 35.28 191.8 171.51 113.15 171.5 120.25 35.3 198.89",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.06 258.12 69.19 254.58 69.19 95.06 63.05 98.6 63.06 258.12",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.7 215.03 143.83 211.49 143.83 51.96 137.7 55.51 137.7 215.03",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.05 175.77 59.74 173.86 59.74 107.61 63.05 105.7 63.05 175.77",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.68 132.68 134.37 130.78 134.37 64.52 137.68 62.61 137.68 132.68",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "299.07 107.51 300.73 108.5 334.89 88.78 333.23 87.79 299.07 107.51",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.23 87.79 300.73 106.54 300.73 72.52 333.23 53.77 333.23 87.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,47.36,297.59,70.7v43.24L338,90.59Zm-3.14,41.42L300.73,108.5v-36L334.89,52.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.89 88.78 333.23 87.79 333.23 53.77 334.89 52.8 334.89 88.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.03 47.35 336.34 46.39 295.9 69.74 297.59 70.7 338.03 47.35",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.9 69.74 297.59 70.7 297.59 113.94 295.9 112.97 295.9 69.74",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "331.96 86.77 302 104.06 302 95.42 309.49 78.12 314.16 82.45 312.48 89.69 322.82 67.57 331.96 78.12 331.96 86.77",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.87,69.77a4.92,4.92,0,0,0-2.21,3.84c0,1.41,1,2,2.21,1.28a4.9,4.9,0,0,0,2.22-3.84C316.09,69.64,315.1,69.07,313.87,69.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "299.07 165.5 300.73 166.49 334.89 146.77 333.23 145.77 299.07 165.5",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.23 145.77 300.73 164.53 300.73 130.5 333.23 111.76 333.23 145.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,105.34l-40.44,23.35v43.24L338,148.58Zm-3.14,41.43-34.16,19.72v-36l34.16-19.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.89 146.77 333.23 145.77 333.23 111.76 334.89 110.78 334.89 146.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.03 105.34 336.34 104.38 295.9 127.72 297.59 128.69 338.03 105.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.9 127.72 297.59 128.69 297.59 171.93 295.9 170.96 295.9 127.72",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "331.96 144.76 302 162.05 302 153.4 309.49 136.11 314.16 140.43 312.48 147.68 322.82 125.56 331.96 136.11 331.96 144.76",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.87,127.76a4.9,4.9,0,0,0-2.21,3.84c0,1.41,1,2,2.21,1.28a4.9,4.9,0,0,0,2.22-3.84C316.09,127.62,315.1,127.05,313.87,127.76Z",
    style: {
      fill: "#f0f0f0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-5",
    cx: 396.1,
    cy: 416.76,
    rx: 73.46,
    ry: 42.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M273,376.51l-10.4-6c-5.13-3-5.13-7.78,0-10.74l64.61-37.28c5.14-3,13.46-3,18.6,0l10.39,6c5.14,3,5.14,7.78,0,10.74l-64.6,37.28C286.44,379.48,278.11,379.48,273,376.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M101.39,437a12,12,0,0,1-1.91,4.44,21.1,21.1,0,0,1-7.16,6.35c-12.39,7.16-32.48,7.16-44.87,0a21.1,21.1,0,0,1-7.16-6.35,12.19,12.19,0,0,1-1.9-4.44h0c-1.11-5.38,1.92-11,9.06-15.11,12.39-7.16,32.48-7.16,44.87,0C99.46,426,102.49,431.61,101.39,437Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M244.36,354.12,93.68,441.06c-1.76,1-1.76,2.67,0,3.68l23.58,13.58a7,7,0,0,0,6.38,0l150.68-86.94c1.77-1,1.77-2.67,0-3.69l-23.58-13.57A7,7,0,0,0,244.36,354.12Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.81,435.08l-7.25,3.36a2.77,2.77,0,0,1-1.66.1,42.26,42.26,0,0,0-5.62-1.34,1.38,1.38,0,0,1-1.05-1l-.9-4.77a1.12,1.12,0,0,0-1.06-.88H238.76a1.13,1.13,0,0,0-1.06.88l-.9,4.77a1.35,1.35,0,0,1-1.05,1,42.26,42.26,0,0,0-5.62,1.34,2.77,2.77,0,0,1-1.66-.1l-7.24-3.36a2,2,0,0,0-1.59.07l-7.14,4.13a.53.53,0,0,0-.05,1l5.66,4.08a.75.75,0,0,1,.11,1.16,14.25,14.25,0,0,0-2,2.81,1.78,1.78,0,0,1-1.29.85l-9.52.6a1,1,0,0,0-.89.95V456a1,1,0,0,0,.89.94l9.52.61a1.78,1.78,0,0,1,1.29.85,14.25,14.25,0,0,0,2,2.81.75.75,0,0,1-.11,1.16l-5.66,4.07a.53.53,0,0,0,.05,1l7.14,4.13a2,2,0,0,0,1.59.07l7.24-3.36a2.62,2.62,0,0,1,1.66-.1,42.26,42.26,0,0,0,5.62,1.34,1.35,1.35,0,0,1,1.05,1l.9,4.77a1.14,1.14,0,0,0,1.06.88h10.51a1.13,1.13,0,0,0,1.06-.88l.9-4.77a1.37,1.37,0,0,1,1.05-1,42.26,42.26,0,0,0,5.62-1.34,2.62,2.62,0,0,1,1.66.1l7.25,3.36a2,2,0,0,0,1.58-.07l7.14-4.13a.53.53,0,0,0,.05-1l-5.66-4.07a.75.75,0,0,1-.11-1.16,14.25,14.25,0,0,0,2-2.81,1.78,1.78,0,0,1,1.29-.85l9.52-.61a1,1,0,0,0,.89-.94v-5.32a1,1,0,0,0-.89-.95l-9.52-.6a1.74,1.74,0,0,1-1.28-.85,14.74,14.74,0,0,0-2-2.81.75.75,0,0,1,.11-1.16l5.66-4.08a.53.53,0,0,0-.05-1l-7.14-4.13A1.94,1.94,0,0,0,266.81,435.08Zm-10.72,11.3c6.67,3.85,6.67,10.09,0,13.94s-17.48,3.85-24.15,0-6.66-10.09,0-13.94S249.42,442.53,256.09,446.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.3,403.51,291.93,406a2,2,0,0,1-1.23.07,34.12,34.12,0,0,0-4.16-1,1,1,0,0,1-.78-.75l-.67-3.54a.83.83,0,0,0-.78-.65h-7.79a.83.83,0,0,0-.78.65l-.67,3.54a1,1,0,0,1-.78.75,34.73,34.73,0,0,0-4.17,1,2,2,0,0,1-1.22-.07l-5.37-2.49a1.41,1.41,0,0,0-1.17.06l-5.3,3.05a.4.4,0,0,0,0,.72l4.19,3a.55.55,0,0,1,.08.86,10.89,10.89,0,0,0-1.5,2.08,1.29,1.29,0,0,1-.95.63l-7.06.45a.72.72,0,0,0-.66.7V419a.72.72,0,0,0,.66.7l7.06.44a1.33,1.33,0,0,1,.95.64,10.89,10.89,0,0,0,1.5,2.08.55.55,0,0,1-.08.86l-4.19,3a.39.39,0,0,0,0,.71l5.3,3.06a1.41,1.41,0,0,0,1.17.05l5.37-2.48a1.89,1.89,0,0,1,1.22-.08,31.29,31.29,0,0,0,4.17,1,1,1,0,0,1,.78.76l.67,3.53a.83.83,0,0,0,.78.65h7.79a.83.83,0,0,0,.78-.65l.67-3.53a1,1,0,0,1,.78-.76,30.78,30.78,0,0,0,4.16-1,1.92,1.92,0,0,1,1.23.08l5.37,2.48a1.41,1.41,0,0,0,1.17-.05l5.29-3.06a.39.39,0,0,0,0-.71l-4.2-3a.56.56,0,0,1-.07-.86A10.41,10.41,0,0,0,301,420.8a1.34,1.34,0,0,1,1-.64l7-.44a.71.71,0,0,0,.66-.7v-3.94a.71.71,0,0,0-.66-.7l-7-.45a1.3,1.3,0,0,1-1-.63,10.41,10.41,0,0,0-1.49-2.08.56.56,0,0,1,.07-.86l4.2-3a.4.4,0,0,0,0-.72l-5.29-3.05A1.41,1.41,0,0,0,297.3,403.51Zm-7.94,8.37c4.94,2.86,4.94,7.48,0,10.33s-12.95,2.85-17.89,0-4.94-7.47,0-10.33S284.42,409,289.36,411.88Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.42,408.55H41.34l5.91,24.58h0c.45,3,2.64,5.86,6.57,8.13,8.87,5.12,23.26,5.12,32.14,0,4.23-2.44,6.42-5.61,6.62-8.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.46,425.4A24.21,24.21,0,0,0,94.88,423l3.22-13.14a23.25,23.25,0,0,1-5.78,4.59c-12,7-31.34,7.12-43.79.56L50,409.17l-.45-.62H41.35l5.9,24.57h0c.45,3,2.64,5.86,6.57,8.13,6.32,3.65,15.43,4.68,23.37,3.13-14.22,1.06-24-5.15-25.44-10.89-.59-2.28-1.61-7.34-1.61-7.34C62,432.18,80.11,431.94,91.46,425.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.39,401.28a12,12,0,0,1-1.91,4.43,21.11,21.11,0,0,1-7.16,6.36c-12.39,7.15-32.48,7.15-44.87,0a21.11,21.11,0,0,1-7.16-6.36,12.15,12.15,0,0,1-1.9-4.43h0c-1.11-5.38,1.92-11,9.06-15.11,12.39-7.16,32.48-7.16,44.87,0C99.46,390.29,102.49,395.9,101.39,401.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.48,405.71a21.11,21.11,0,0,1-7.16,6.36c-12.39,7.15-32.48,7.15-44.87,0a21.11,21.11,0,0,1-7.16-6.36,12.15,12.15,0,0,1-1.9-4.43h0l1.4,9.67c.65,3.89,3.55,7.68,8.72,10.67,11.81,6.81,30.94,6.81,42.75,0,5.1-2.95,8-6.7,8.69-10.53l.07-.5,1.37-9.31A12,12,0,0,1,99.48,405.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.58,388.33c-10.32-6-27.07-6-37.38,0-5.85,3.37-8.38,7.93-7.61,12.33.58,3.38,3.12,6.66,7.61,9.25,10.31,6,27.06,6,37.38,0,4.48-2.59,7-5.87,7.61-9.24C97,396.26,94.43,391.7,88.58,388.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.33,404.75a17.65,17.65,0,0,0,5.87,5.16c10.31,6,27.06,6,37.38,0a17.82,17.82,0,0,0,5.86-5.16c-.07-3.58-2.46-7.13-7.18-9.85-9.6-5.55-25.15-5.55-34.74,0C47.8,397.62,45.41,401.18,45.33,404.75Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.69,314.79a5.55,5.55,0,0,1,0-.73c0-.26,0-.51-.07-.76-.06-.5-.14-1-.23-1.5a27.07,27.07,0,0,0-.74-2.95,1.7,1.7,0,0,0-.17-.57l-.18-.57-.39-1.16-.57-1.65a13,13,0,0,1-.53-1.6,3.3,3.3,0,0,0-.15-.62,1.17,1.17,0,0,1-.11-.28c-.05-.26-.1-.54-.16-.81-.11-.53-.24-1.07-.38-1.6-.29-1.07-.62-2.12-1-3.15-.3-.82-.63-1.62-1-2.41a8.34,8.34,0,0,0-2.72-3.67,1.13,1.13,0,0,0-1.09-.2c-.37.19-.44.68-.47,1.1l-.48,7.06a20.5,20.5,0,0,0,0,4.36,10.43,10.43,0,0,0,2.42,5.32A21.37,21.37,0,0,0,50.5,311c.77.61,1.55,1.21,2.29,1.85A10.2,10.2,0,0,0,55.69,314.79Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.59,299.93c-.06-.34-.13-.68-.22-1a6.92,6.92,0,0,0-.86-2c-.2-.31-.3-.67-.48-1a3.6,3.6,0,0,0-.72-.88,1.46,1.46,0,0,0-.61-.33.65.65,0,0,0-.63.19,1,1,0,0,0-.16.56,20,20,0,0,1-.75,3.74,12.72,12.72,0,0,1-.64,1.79,3.21,3.21,0,0,1-.34.48,1.68,1.68,0,0,0-.2.35,10.88,10.88,0,0,1-1,1.69,10.11,10.11,0,0,1-.95,1.11c-1.09,1.11-2.47,2-3.3,3.27-1.25,2-1,4.48-1.09,6.71,0,.38,0,.76,0,1.14,0,3.06-.5,5.7.28,8.71.06.21.28.73.61.53l.34-.22a11.31,11.31,0,0,0,3.42-5.07l.6-1.5a3.74,3.74,0,0,1,.71-1c.74-1,1.38-2,2-3.07a30.91,30.91,0,0,0,3.25-6.57,17.08,17.08,0,0,0,.89-5.26A14.48,14.48,0,0,0,69.59,299.93Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.42,324c.58,0,1.16.05,1.74.06,1.19,0,2.38,0,3.57-.05h1.78c.21,0,.4,0,.61,0a6.17,6.17,0,0,0,.86,0,.22.22,0,0,0,.16-.05.28.28,0,0,0,.09-.25,5.23,5.23,0,0,0-.57-2.36,4.84,4.84,0,0,0-.68-1,9.33,9.33,0,0,0-3.06-2.41,16.47,16.47,0,0,0-3.59-1.06l-9.7-2.07a1.33,1.33,0,0,0-1.29.17,1.18,1.18,0,0,0-.23.71,7.14,7.14,0,0,0,3.29,6.25A13.8,13.8,0,0,0,48.42,324Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.06,335.91a5.61,5.61,0,0,0-1.14-1.42A7.54,7.54,0,0,0,55.65,333a25.34,25.34,0,0,0-4.38-1.29,52.19,52.19,0,0,1-9.93-3.54,1.26,1.26,0,0,0-.67-.19c-.57.06-.79.76-.82,1.33a8.24,8.24,0,0,0,4.34,7.59c2.68,1.38,5.86,1.17,8.87,1.06h.13a23.51,23.51,0,0,1,3.25.06,12.38,12.38,0,0,1,1.6.25c.44.1,1.25.58,1.53,0a1.12,1.12,0,0,0,0-.68,5.4,5.4,0,0,0-.54-1.6Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.35,336.76a2.15,2.15,0,0,1-.46.33.76.76,0,0,1-.38.11A.54.54,0,0,1,61,337a2.75,2.75,0,0,1-.17-.29,5.63,5.63,0,0,1-.27-.61,7.16,7.16,0,0,1-.32-1.31c0-.1,0-.21,0-.32-.06-.5-.1-1-.15-1.5,0-.26,0-.51-.09-.76a1.77,1.77,0,0,1,0-.56,4.73,4.73,0,0,0,0-.92,8.54,8.54,0,0,1,0-1.13c.28-3.33,2.71-6,4.72-8.7a42.09,42.09,0,0,0,4.6-7.83c.27-.61.72-1.34,1.38-1.24s.81.65,1,1.16a17.64,17.64,0,0,1-.28,11.12,24.45,24.45,0,0,1-3,6,31.37,31.37,0,0,1-2.07,2.68c-.21.25-.41.51-.64.75-.69.75-1.4,1.48-2.11,2.21l-.89.88Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,346a27.9,27.9,0,0,0-6.87-1.36,16,16,0,0,1-6.68-2,1.23,1.23,0,0,0-.69-.28c-.48,0-.73.58-.79,1.06a6.51,6.51,0,0,0,1.1,4.11,12.34,12.34,0,0,0,12.29,5.61h0c1.51-.26,3-.81,4.51-1a7.11,7.11,0,0,1,1.13,0c.24,0,.63.16.82-.05.41-.43-.07-1-.18-1.46a4.82,4.82,0,0,0-.67-1.48,7.63,7.63,0,0,0-2.34-2.29A8.92,8.92,0,0,0,56.21,346Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.36,359.7c-2.32-.58-4.74-.7-7-1.5-1-.36-2-.85-2.95-1.26-.28-.11-.63-.2-.84,0a.68.68,0,0,0-.15.5A7.84,7.84,0,0,0,49,363.88a13.14,13.14,0,0,0,7.24,2.05c1.53,0,3-.13,4.58,0a3.46,3.46,0,0,1,1.06.17c.18.07.29.27.47.33.67.23.76-.74.69-1.16a5.71,5.71,0,0,0-.9-2.21,4.58,4.58,0,0,0-.78-.92,1.58,1.58,0,0,0-.38-.21c-.66-.32-1.21-.87-1.86-1.21A11.44,11.44,0,0,0,56.36,359.7Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.24,365.79a24.88,24.88,0,0,0-3.42-1.62L36,361a1.21,1.21,0,0,0-1.15-.07,1.08,1.08,0,0,0-.36.82A8.29,8.29,0,0,0,35,365c1.47,4.53,5.37,8.34,10.07,9.06,2,.31,4,.09,5.93.54.77.18,2,.43,2.05-.74a1.76,1.76,0,0,0-.32-.83c-.19-.39-.28-.82-.44-1.22a12.41,12.41,0,0,0-2.75-4.24A12,12,0,0,0,47.24,365.79Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.23,379a19.1,19.1,0,0,0-4.91-1.22l-4.49-.7c-.57-.1-1.15-.17-1.73-.28a.93.93,0,0,1-.24-.05,1.3,1.3,0,0,0-.74-.17c-.33.06-.38.28-.41.57a5.25,5.25,0,0,0,.16,1.77A6.54,6.54,0,0,0,40.78,382a11.24,11.24,0,0,0,5.41,2.47,20.77,20.77,0,0,0,4.85.39c1.36-.05,2.73-.34,3.39-1.66.59-1.15-.43-2.23-1.25-3A8,8,0,0,0,51.23,379Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.35,369.54a1.9,1.9,0,0,1,.09-1,1.12,1.12,0,0,1,1.13-.55,2.18,2.18,0,0,1,1.17.59c1.38,1.24,1.73,3.24,1.9,5.09a17.07,17.07,0,0,1-.2,5.66c-.33,1.36-1,3.11-2.51,3.43a2.65,2.65,0,0,1-2.79-1.33c-.87-1.57-.11-3.66.28-5.26a24.63,24.63,0,0,0,.95-6C56.37,370,56.36,369.78,56.35,369.54Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.07,389.51a21.42,21.42,0,0,0-5.94-1.32l-2.24-.27a1.11,1.11,0,0,0-.48,0c-.49.15-.53.84-.37,1.33.67,2.12,3,3.26,5.18,3.68s4.5.37,6.55,1.24c.48.2,1.23.53,1.55-.09.24-.47-.2-.86-.41-1.25a7.12,7.12,0,0,0-2.2-2.43A9.7,9.7,0,0,0,53.07,389.51Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.53,386.84c.71-1.74,2.21-3.15,2.52-5a1,1,0,0,1,1,.43,2.82,2.82,0,0,1,.39,1.06,21.35,21.35,0,0,1,.69,4.33A7.1,7.1,0,0,1,61,391.83a2.48,2.48,0,0,1-1.8,1.16,2.12,2.12,0,0,1-1.7-.67c-.67-.74-.47-1.82-.42-2.74A8.25,8.25,0,0,1,57.53,386.84Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,304.31c1.82-3.83,5.13-6.89,6.47-10.92a1.16,1.16,0,0,1,.29-.56.8.8,0,0,1,1,.12,2.14,2.14,0,0,1,.49,1,16.83,16.83,0,0,1,.39,9.19,31,31,0,0,1-1.65,4,72.31,72.31,0,0,1-3.11,7A13.56,13.56,0,0,1,96,317.44c-.77.7-2.13,1.92-3,.62a3.64,3.64,0,0,1-.32-1.93c0-.77,0-1.55,0-2.32a30.87,30.87,0,0,1,.43-4.61,19.57,19.57,0,0,1,1.28-4.37C94.56,304.66,94.64,304.49,94.72,304.31Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.55,318.8A19.51,19.51,0,0,0,86,313l-4.11-7.2c-.11-.19-.25-.4-.46-.41s-.41.2-.53.39c-1.94,3.17-1.86,7.27-.57,10.74a29.1,29.1,0,0,0,6.19,9.18,1.15,1.15,0,0,0,1.25.46,1.65,1.65,0,0,0,.81-1.27,1.35,1.35,0,0,0-.06-.49,7.22,7.22,0,0,1,.09-1.39c0-.57.1-1.14.11-1.71A12.1,12.1,0,0,0,88.55,318.8Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.73,316.25l4-2a.52.52,0,0,1,.34-.09c.2,0,.29.27.33.46a6.16,6.16,0,0,1-.7,4.15,13.44,13.44,0,0,1-2.68,3.33,32.43,32.43,0,0,1-3.35,2.84,30.69,30.69,0,0,1-3.75,2.37,27,27,0,0,1-4.05,1.78,24.83,24.83,0,0,1-4.26,1.07c-.76.12-1.78.25-1.93-.76a4.39,4.39,0,0,1,.78-2.63A11.52,11.52,0,0,1,91.92,324a34,34,0,0,1,3.68-2.77c1.29-.85,2.62-1.63,4-2.37s2.74-1.44,4.13-2.13Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.05,331.29A26.67,26.67,0,0,0,79.7,328a58.15,58.15,0,0,1-2.88-8c-.45,0-.82.34-1.09.69a13.62,13.62,0,0,0-2.9,7.55,10,10,0,0,0,2.73,7.49c1.4,1.42,3.31,2.38,4.31,4.11.18.32.37.7.73.81a.52.52,0,0,0,.57-.26c.11-.21-.06-.41,0-.63.07-.69.17-1.38.24-2.07a20.71,20.71,0,0,0,.08-4.09A12.11,12.11,0,0,0,81.05,331.29Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.56,336.77c2.06-1.69,4.83-2.18,7.47-2.51s5.39-.59,7.67-1.95a1.86,1.86,0,0,1,.83-.33c.77,0,1.1,1,1,1.78a7.19,7.19,0,0,1-1.49,2.92,13.24,13.24,0,0,1-2.2,2.41c-2.92,2.4-7,2.61-10.79,2.7l-2.72.07-1.38,0a11.63,11.63,0,0,1-1.32,0c-.68-.07-.13-.89,0-1.22.38-.67.74-1.34,1.18-2A9.6,9.6,0,0,1,85.56,336.77Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.34,346.69a16.17,16.17,0,0,0-1.64-3.24L70.42,338c-.35-.57-.8-1.21-1.47-1.24-1.56,4.2-2.42,9.05-.41,13.05a20.59,20.59,0,0,0,2.54,3.63l2.78,3.4c.38.46,1.09,1,1.72.62.29-.15.34-.52.4-.81a9.38,9.38,0,0,0,.16-1.4,4.44,4.44,0,0,0,0-1,15.15,15.15,0,0,1-.23-3A14.06,14.06,0,0,0,75.34,346.69Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.17,348.61a11.49,11.49,0,0,1,2.94-1.11c1.2-.26,2.43-.27,3.65-.42,2-.25,3.93-.87,5.92-1.17a1,1,0,0,1,.6,0,.91.91,0,0,1,.39.8,6.91,6.91,0,0,1-1,3.86,13.93,13.93,0,0,1-9.26,6.78,34.4,34.4,0,0,1-5.36.44,26.41,26.41,0,0,0-2.68.23c-.45.07-.9.15-1.33.26a1.29,1.29,0,0,1-.82.05c-.44-.2-.46-.8-.42-1.21a5,5,0,0,1,.65-1.82,16.39,16.39,0,0,1,2.68-3.67,15.69,15.69,0,0,1,3.55-2.78Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.18,358.83a35.62,35.62,0,0,0-.55,5.55,18.32,18.32,0,0,0,1,6.94,24.44,24.44,0,0,0,4.19,6.41.78.78,0,0,0,.36.29c.32.07.56-.29.69-.6a16.26,16.26,0,0,0,.9-8.73,17,17,0,0,0-1.33-4.33c-.29-.62-.72-1.2-1-1.84-.06-.15-.09-.31-.14-.46a10.77,10.77,0,0,0-.77-1.36,18.1,18.1,0,0,1-1.33-3,1.77,1.77,0,0,0-.56-.95.63.63,0,0,0-.65,0c-.24.14-.2.34-.3.55s-.26.47-.35.75A5.42,5.42,0,0,0,66.18,358.83Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.37,365.8a9.93,9.93,0,0,1,2.87-3.27,12.6,12.6,0,0,1,3.11-1.32l8.12-2.62c.52,3-.88,6-2.94,8.24a29.56,29.56,0,0,1-7,5.1c-1.8,1-3.64,1.82-4.63,2.5-.45.3-.89.61-1.32.94s-1,.79-1.31.41c-.17-.18-.06-.51,0-.72s.13-.63.21-.94.21-.78.33-1.17.21-.77.3-1.16c0-.19.06-.38.11-.57a16.93,16.93,0,0,1,.81-2.8A18.42,18.42,0,0,1,76.37,365.8Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,393.29a15.07,15.07,0,0,0-.56-3.71,8.25,8.25,0,0,0-2.49-4.47,3.24,3.24,0,0,0-2.51-.7l.78,5.3c0,.19,0,.38.08.57a9.41,9.41,0,0,0,1.23,3.86,4.62,4.62,0,0,0,.69.71,8.56,8.56,0,0,0,1.56,1.25l.26.15a.9.9,0,0,0,.41.13c.5,0,.44-.78.48-1.12a14.72,14.72,0,0,0,.07-1.76Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.32,386.63A15.24,15.24,0,0,0,89.15,385c.19-.14.44-.3.65-.17a.47.47,0,0,1,.21.34c.37,1.29-.34,2.63-1.15,3.7a14.25,14.25,0,0,1-3.42,3.29,10.05,10.05,0,0,1-4.3,1.7c-.91.12-2.92.29-2.54-1.2a5,5,0,0,1,.89-1.61,15.5,15.5,0,0,1,1.43-1.7c1.32-1.31,3.13-1.82,4.81-2.49Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.56,376.92a15.36,15.36,0,0,1,9.88.34,4.27,4.27,0,0,1,2.12,1.32,1.7,1.7,0,0,1-.12,2.28,2.75,2.75,0,0,1-1,.39L82.12,385a3.42,3.42,0,0,1-1.23.13c-.2,0-.38-.13-.57-.16s-.32.07-.43-.12a.8.8,0,0,1-.06-.38,4.36,4.36,0,0,1,.08-1,1.62,1.62,0,0,1,.15-.42c.17-.33.3-.69.47-1a10,10,0,0,1,3.4-3.85A11.14,11.14,0,0,1,86.56,376.92Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3,367.74c2.63-1.38,5.71-1.51,8.68-1.61a.7.7,0,0,1,.49.12.61.61,0,0,1,.13.33,4.54,4.54,0,0,1-1.41,3.57A11.61,11.61,0,0,1,93.4,373a23.9,23.9,0,0,1-4.33,1.35l-4,.95c-.26.07-.87.38-1.11.2s0-1,.05-1.26a8.75,8.75,0,0,1,.75-1.5A11.9,11.9,0,0,1,86.47,370,9.84,9.84,0,0,1,89.3,367.74Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.92,376.22c-.08-.05-.18-.11-.26-.07s-.09.12-.11.19a2.88,2.88,0,0,0-.12.64v.18a1.93,1.93,0,0,1-.11.52,6.12,6.12,0,0,0-.11,1.21,6.89,6.89,0,0,0,.16,1.28A9.07,9.07,0,0,0,75.62,383a5.9,5.9,0,0,0,.43.59c.18.2.39.38.58.57a7.7,7.7,0,0,1,1.08,1.45c.09.14.22.31.38.28a.4.4,0,0,0,.24-.2,1.69,1.69,0,0,0,.38-.61c.05-.24.11-.48.14-.72a.49.49,0,0,1,0-.12,9.14,9.14,0,0,0-1.25-5.43A9.36,9.36,0,0,0,74.92,376.22Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.69,314.79a5.55,5.55,0,0,1,0-.73c0-.26,0-.51-.07-.76-.06-.5-.14-1-.23-1.5a27.07,27.07,0,0,0-.74-2.95,1.7,1.7,0,0,0-.17-.57l-.18-.57-.39-1.16-.57-1.65a13,13,0,0,1-.53-1.6,3.3,3.3,0,0,0-.15-.62,1.17,1.17,0,0,1-.11-.28c-.05-.26-.1-.54-.16-.81-.11-.53-.24-1.07-.38-1.6-.29-1.07-.62-2.12-1-3.15-.3-.82-.63-1.62-1-2.41a8.34,8.34,0,0,0-2.72-3.67,1.13,1.13,0,0,0-1.09-.2c-.37.19-.44.68-.47,1.1l-.48,7.06a20.5,20.5,0,0,0,0,4.36,10.43,10.43,0,0,0,2.42,5.32A21.37,21.37,0,0,0,50.5,311c.77.61,1.55,1.21,2.29,1.85A10.2,10.2,0,0,0,55.69,314.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.06,335.91a5.61,5.61,0,0,0-1.14-1.42A7.54,7.54,0,0,0,55.65,333a25.34,25.34,0,0,0-4.38-1.29,52.19,52.19,0,0,1-9.93-3.54,1.26,1.26,0,0,0-.67-.19c-.57.06-.79.76-.82,1.33a8.24,8.24,0,0,0,4.34,7.59c2.68,1.38,5.86,1.17,8.87,1.06h.13a23.51,23.51,0,0,1,3.25.06,12.38,12.38,0,0,1,1.6.25c.44.1,1.25.58,1.53,0a1.12,1.12,0,0,0,0-.68,5.4,5.4,0,0,0-.54-1.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.35,336.76a2.15,2.15,0,0,1-.46.33.76.76,0,0,1-.38.11A.54.54,0,0,1,61,337a2.75,2.75,0,0,1-.17-.29,5.63,5.63,0,0,1-.27-.61,7.16,7.16,0,0,1-.32-1.31c0-.1,0-.21,0-.32-.06-.5-.1-1-.15-1.5,0-.26,0-.51-.09-.76a1.77,1.77,0,0,1,0-.56,4.73,4.73,0,0,0,0-.92,8.54,8.54,0,0,1,0-1.13c.28-3.33,2.71-6,4.72-8.7a42.09,42.09,0,0,0,4.6-7.83c.27-.61.72-1.34,1.38-1.24s.81.65,1,1.16a17.64,17.64,0,0,1-.28,11.12,24.45,24.45,0,0,1-3,6,31.37,31.37,0,0,1-2.07,2.68c-.21.25-.41.51-.64.75-.69.75-1.4,1.48-2.11,2.21l-.89.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.36,359.7c-2.32-.58-4.74-.7-7-1.5-1-.36-2-.85-2.95-1.26-.28-.11-.63-.2-.84,0a.68.68,0,0,0-.15.5A7.84,7.84,0,0,0,49,363.88a13.14,13.14,0,0,0,7.24,2.05c1.53,0,3-.13,4.58,0a3.46,3.46,0,0,1,1.06.17c.18.07.29.27.47.33.67.23.76-.74.69-1.16a5.71,5.71,0,0,0-.9-2.21,4.58,4.58,0,0,0-.78-.92,1.58,1.58,0,0,0-.38-.21c-.66-.32-1.21-.87-1.86-1.21A11.44,11.44,0,0,0,56.36,359.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.24,365.79a24.88,24.88,0,0,0-3.42-1.62L36,361a1.21,1.21,0,0,0-1.15-.07,1.08,1.08,0,0,0-.36.82A8.29,8.29,0,0,0,35,365c1.47,4.53,5.37,8.34,10.07,9.06,2,.31,4,.09,5.93.54.77.18,2,.43,2.05-.74a1.76,1.76,0,0,0-.32-.83c-.19-.39-.28-.82-.44-1.22a12.41,12.41,0,0,0-2.75-4.24A12,12,0,0,0,47.24,365.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.23,379a19.1,19.1,0,0,0-4.91-1.22l-4.49-.7c-.57-.1-1.15-.17-1.73-.28a.93.93,0,0,1-.24-.05,1.3,1.3,0,0,0-.74-.17c-.33.06-.38.28-.41.57a5.25,5.25,0,0,0,.16,1.77A6.54,6.54,0,0,0,40.78,382a11.24,11.24,0,0,0,5.41,2.47,20.77,20.77,0,0,0,4.85.39c1.36-.05,2.73-.34,3.39-1.66.59-1.15-.43-2.23-1.25-3A8,8,0,0,0,51.23,379Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.07,389.51a21.42,21.42,0,0,0-5.94-1.32l-2.24-.27a1.11,1.11,0,0,0-.48,0c-.49.15-.53.84-.37,1.33.67,2.12,3,3.26,5.18,3.68s4.5.37,6.55,1.24c.48.2,1.23.53,1.55-.09.24-.47-.2-.86-.41-1.25a7.12,7.12,0,0,0-2.2-2.43A9.7,9.7,0,0,0,53.07,389.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,304.31c1.82-3.83,5.13-6.89,6.47-10.92a1.16,1.16,0,0,1,.29-.56.8.8,0,0,1,1,.12,2.14,2.14,0,0,1,.49,1,16.83,16.83,0,0,1,.39,9.19,31,31,0,0,1-1.65,4,72.31,72.31,0,0,1-3.11,7A13.56,13.56,0,0,1,96,317.44c-.77.7-2.13,1.92-3,.62a3.64,3.64,0,0,1-.32-1.93c0-.77,0-1.55,0-2.32a30.87,30.87,0,0,1,.43-4.61,19.57,19.57,0,0,1,1.28-4.37C94.56,304.66,94.64,304.49,94.72,304.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.55,318.8A19.51,19.51,0,0,0,86,313l-4.11-7.2c-.11-.19-.25-.4-.46-.41s-.41.2-.53.39c-1.94,3.17-1.86,7.27-.57,10.74a29.1,29.1,0,0,0,6.19,9.18,1.15,1.15,0,0,0,1.25.46,1.65,1.65,0,0,0,.81-1.27,1.35,1.35,0,0,0-.06-.49,7.22,7.22,0,0,1,.09-1.39c0-.57.1-1.14.11-1.71A12.1,12.1,0,0,0,88.55,318.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.56,336.77c2.06-1.69,4.83-2.18,7.47-2.51s5.39-.59,7.67-1.95a1.86,1.86,0,0,1,.83-.33c.77,0,1.1,1,1,1.78a7.19,7.19,0,0,1-1.49,2.92,13.24,13.24,0,0,1-2.2,2.41c-2.92,2.4-7,2.61-10.79,2.7l-2.72.07-1.38,0a11.63,11.63,0,0,1-1.32,0c-.68-.07-.13-.89,0-1.22.38-.67.74-1.34,1.18-2A9.6,9.6,0,0,1,85.56,336.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.18,358.83a35.62,35.62,0,0,0-.55,5.55,18.32,18.32,0,0,0,1,6.94,24.44,24.44,0,0,0,4.19,6.41.78.78,0,0,0,.36.29c.32.07.56-.29.69-.6a16.26,16.26,0,0,0,.9-8.73,17,17,0,0,0-1.33-4.33c-.29-.62-.72-1.2-1-1.84-.06-.15-.09-.31-.14-.46a10.77,10.77,0,0,0-.77-1.36,18.1,18.1,0,0,1-1.33-3,1.77,1.77,0,0,0-.56-.95.63.63,0,0,0-.65,0c-.24.14-.2.34-.3.55s-.26.47-.35.75A5.42,5.42,0,0,0,66.18,358.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.37,365.8a9.93,9.93,0,0,1,2.87-3.27,12.6,12.6,0,0,1,3.11-1.32l8.12-2.62c.52,3-.88,6-2.94,8.24a29.56,29.56,0,0,1-7,5.1c-1.8,1-3.64,1.82-4.63,2.5-.45.3-.89.61-1.32.94s-1,.79-1.31.41c-.17-.18-.06-.51,0-.72s.13-.63.21-.94.21-.78.33-1.17.21-.77.3-1.16c0-.19.06-.38.11-.57a16.93,16.93,0,0,1,.81-2.8A18.42,18.42,0,0,1,76.37,365.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,393.29a15.07,15.07,0,0,0-.56-3.71,8.25,8.25,0,0,0-2.49-4.47,3.24,3.24,0,0,0-2.51-.7l.78,5.3c0,.19,0,.38.08.57a9.41,9.41,0,0,0,1.23,3.86,4.62,4.62,0,0,0,.69.71,8.56,8.56,0,0,0,1.56,1.25l.26.15a.9.9,0,0,0,.41.13c.5,0,.44-.78.48-1.12a14.72,14.72,0,0,0,.07-1.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.32,386.63A15.24,15.24,0,0,0,89.15,385c.19-.14.44-.3.65-.17a.47.47,0,0,1,.21.34c.37,1.29-.34,2.63-1.15,3.7a14.25,14.25,0,0,1-3.42,3.29,10.05,10.05,0,0,1-4.3,1.7c-.91.12-2.92.29-2.54-1.2a5,5,0,0,1,.89-1.61,15.5,15.5,0,0,1,1.43-1.7c1.32-1.31,3.13-1.82,4.81-2.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3,367.74c2.63-1.38,5.71-1.51,8.68-1.61a.7.7,0,0,1,.49.12.61.61,0,0,1,.13.33,4.54,4.54,0,0,1-1.41,3.57A11.61,11.61,0,0,1,93.4,373a23.9,23.9,0,0,1-4.33,1.35l-4,.95c-.26.07-.87.38-1.11.2s0-1,.05-1.26a8.75,8.75,0,0,1,.75-1.5A11.9,11.9,0,0,1,86.47,370,9.84,9.84,0,0,1,89.3,367.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.92,376.22c-.08-.05-.18-.11-.26-.07s-.09.12-.11.19a2.88,2.88,0,0,0-.12.64v.18a1.93,1.93,0,0,1-.11.52,6.12,6.12,0,0,0-.11,1.21,6.89,6.89,0,0,0,.16,1.28A9.07,9.07,0,0,0,75.62,383a5.9,5.9,0,0,0,.43.59c.18.2.39.38.58.57a7.7,7.7,0,0,1,1.08,1.45c.09.14.22.31.38.28a.4.4,0,0,0,.24-.2,1.69,1.69,0,0,0,.38-.61c.05-.24.11-.48.14-.72a.49.49,0,0,1,0-.12,9.14,9.14,0,0,0-1.25-5.43A9.36,9.36,0,0,0,74.92,376.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.59,299.93c-.06-.34-.13-.68-.22-1a6.92,6.92,0,0,0-.86-2c-.2-.31-.3-.67-.48-1a3.6,3.6,0,0,0-.72-.88,1.46,1.46,0,0,0-.61-.33.65.65,0,0,0-.63.19,1,1,0,0,0-.16.56,20,20,0,0,1-.75,3.74,12.72,12.72,0,0,1-.64,1.79,3.21,3.21,0,0,1-.34.48,1.68,1.68,0,0,0-.2.35,10.88,10.88,0,0,1-1,1.69,10.11,10.11,0,0,1-.95,1.11c-1.09,1.11-2.47,2-3.3,3.27-1.25,2-1,4.48-1.09,6.71,0,.38,0,.76,0,1.14,0,3.06-.5,5.7.28,8.71.06.21.28.73.61.53l.34-.22a11.31,11.31,0,0,0,3.42-5.07l.6-1.5a3.74,3.74,0,0,1,.71-1c.74-1,1.38-2,2-3.07a30.91,30.91,0,0,0,3.25-6.57,17.08,17.08,0,0,0,.89-5.26A14.48,14.48,0,0,0,69.59,299.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.42,324c.58,0,1.16.05,1.74.06,1.19,0,2.38,0,3.57-.05h1.78c.21,0,.4,0,.61,0a6.17,6.17,0,0,0,.86,0,.22.22,0,0,0,.16-.05.28.28,0,0,0,.09-.25,5.23,5.23,0,0,0-.57-2.36,4.84,4.84,0,0,0-.68-1,9.33,9.33,0,0,0-3.06-2.41,16.47,16.47,0,0,0-3.59-1.06l-9.7-2.07a1.33,1.33,0,0,0-1.29.17,1.18,1.18,0,0,0-.23.71,7.14,7.14,0,0,0,3.29,6.25A13.8,13.8,0,0,0,48.42,324Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,346a27.9,27.9,0,0,0-6.87-1.36,16,16,0,0,1-6.68-2,1.23,1.23,0,0,0-.69-.28c-.48,0-.73.58-.79,1.06a6.51,6.51,0,0,0,1.1,4.11,12.34,12.34,0,0,0,12.29,5.61h0c1.51-.26,3-.81,4.51-1a7.11,7.11,0,0,1,1.13,0c.24,0,.63.16.82-.05.41-.43-.07-1-.18-1.46a4.82,4.82,0,0,0-.67-1.48,7.63,7.63,0,0,0-2.34-2.29A8.92,8.92,0,0,0,56.21,346Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.35,369.54a1.9,1.9,0,0,1,.09-1,1.12,1.12,0,0,1,1.13-.55,2.18,2.18,0,0,1,1.17.59c1.38,1.24,1.73,3.24,1.9,5.09a17.07,17.07,0,0,1-.2,5.66c-.33,1.36-1,3.11-2.51,3.43a2.65,2.65,0,0,1-2.79-1.33c-.87-1.57-.11-3.66.28-5.26a24.63,24.63,0,0,0,.95-6C56.37,370,56.36,369.78,56.35,369.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.53,386.84c.71-1.74,2.21-3.15,2.52-5a1,1,0,0,1,1,.43,2.82,2.82,0,0,1,.39,1.06,21.35,21.35,0,0,1,.69,4.33A7.1,7.1,0,0,1,61,391.83a2.48,2.48,0,0,1-1.8,1.16,2.12,2.12,0,0,1-1.7-.67c-.67-.74-.47-1.82-.42-2.74A8.25,8.25,0,0,1,57.53,386.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.73,316.25l4-2a.52.52,0,0,1,.34-.09c.2,0,.29.27.33.46a6.16,6.16,0,0,1-.7,4.15,13.44,13.44,0,0,1-2.68,3.33,32.43,32.43,0,0,1-3.35,2.84,30.69,30.69,0,0,1-3.75,2.37,27,27,0,0,1-4.05,1.78,24.83,24.83,0,0,1-4.26,1.07c-.76.12-1.78.25-1.93-.76a4.39,4.39,0,0,1,.78-2.63A11.52,11.52,0,0,1,91.92,324a34,34,0,0,1,3.68-2.77c1.29-.85,2.62-1.63,4-2.37s2.74-1.44,4.13-2.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.05,331.29A26.67,26.67,0,0,0,79.7,328a58.15,58.15,0,0,1-2.88-8c-.45,0-.82.34-1.09.69a13.62,13.62,0,0,0-2.9,7.55,10,10,0,0,0,2.73,7.49c1.4,1.42,3.31,2.38,4.31,4.11.18.32.37.7.73.81a.52.52,0,0,0,.57-.26c.11-.21-.06-.41,0-.63.07-.69.17-1.38.24-2.07a20.71,20.71,0,0,0,.08-4.09A12.11,12.11,0,0,0,81.05,331.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.34,346.69a16.17,16.17,0,0,0-1.64-3.24L70.42,338c-.35-.57-.8-1.21-1.47-1.24-1.56,4.2-2.42,9.05-.41,13.05a20.59,20.59,0,0,0,2.54,3.63l2.78,3.4c.38.46,1.09,1,1.72.62.29-.15.34-.52.4-.81a9.38,9.38,0,0,0,.16-1.4,4.44,4.44,0,0,0,0-1,15.15,15.15,0,0,1-.23-3A14.06,14.06,0,0,0,75.34,346.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.17,348.61a11.49,11.49,0,0,1,2.94-1.11c1.2-.26,2.43-.27,3.65-.42,2-.25,3.93-.87,5.92-1.17a1,1,0,0,1,.6,0,.91.91,0,0,1,.39.8,6.91,6.91,0,0,1-1,3.86,13.93,13.93,0,0,1-9.26,6.78,34.4,34.4,0,0,1-5.36.44,26.41,26.41,0,0,0-2.68.23c-.45.07-.9.15-1.33.26a1.29,1.29,0,0,1-.82.05c-.44-.2-.46-.8-.42-1.21a5,5,0,0,1,.65-1.82,16.39,16.39,0,0,1,2.68-3.67,15.69,15.69,0,0,1,3.55-2.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.56,376.92a15.36,15.36,0,0,1,9.88.34,4.27,4.27,0,0,1,2.12,1.32,1.7,1.7,0,0,1-.12,2.28,2.75,2.75,0,0,1-1,.39L82.12,385a3.42,3.42,0,0,1-1.23.13c-.2,0-.38-.13-.57-.16s-.32.07-.43-.12a.8.8,0,0,1-.06-.38,4.36,4.36,0,0,1,.08-1,1.62,1.62,0,0,1,.15-.42c.17-.33.3-.69.47-1a10,10,0,0,1,3.4-3.85A11.14,11.14,0,0,1,86.56,376.92Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.69,406.27c-.16-.76-.26-1.55-.48-2.29s-.51-1.68-.75-2.52c-.45-1.53-.84-3.08-1.19-4.64-.72-3.18-1.29-6.38-1.7-9.62-.83-6.5-1.13-13.06-1.4-19.6s-.56-13.15-1.25-19.69c-.42-4-1-7.9-1.69-11.82a20.72,20.72,0,0,1,2.51-5.6,47.1,47.1,0,0,0,3.85-7c0-.1-.06-.27-.13-.13-1.26,2.42-3.23,4.4-4.76,6.64a16.14,16.14,0,0,0-1.9,3.78c-.38-1.94-.78-3.88-1.22-5.8q-.42-1.81-.9-3.63c.1-.67.21-1.34.27-2a20.87,20.87,0,0,1,.36-2.48,24.61,24.61,0,0,1,1.52-4.73c1.26-3,3.42-5.58,4.41-8.69.05-.16-.14-.4-.23-.17a19.18,19.18,0,0,1-2.81,4.59,21.1,21.1,0,0,0-2.72,4.42,20.74,20.74,0,0,0-1.4,4.83c-.08.44-.15.88-.2,1.33a114.11,114.11,0,0,0-5.75-15.69c-.08-.17-.22.08-.19.18,1.71,5.63,3.31,11.29,4.72,17l-.31-.21a11.4,11.4,0,0,0-2.47-1.17c-2.21-.76-4.5-1.28-6.73-2-.13,0-.19.3-.07.34,2.07.72,4.14,1.48,6.19,2.24a19,19,0,0,1,2.41,1,7.28,7.28,0,0,1,1.09.75c.06,0,.12.12.18.18,1.07,4.44,2,8.91,2.77,13.41a10,10,0,0,0-5.61-3.06c-1.52-.31-3.08-.37-4.62-.58a14.23,14.23,0,0,1-4.31-1.35c-.08,0-.11.15-.06.2,2.11,1.93,5.54,2,8.21,2.45a10.89,10.89,0,0,1,4.14,1.41A8.78,8.78,0,0,1,60,339.13c.37,2.26.7,4.52,1,6.8.24,2.1.42,4.2.58,6.31a7.28,7.28,0,0,0-2.36-1.66,15.08,15.08,0,0,0-4.09-1.18c-2.86-.46-5.88-.56-8.33-2.3,0,0-.07.06,0,.08,2,2,4.88,2.48,7.56,3a23.5,23.5,0,0,1,4,1,9,9,0,0,1,1.76.88,18.86,18.86,0,0,1,1.61,1.35c.27,3.82.44,7.64.6,11.47a6,6,0,0,0-.82-.73,7.23,7.23,0,0,0-2.5-1.16c-2.23-.58-4.59-.25-6.78-1-.1,0-.15.2-.05.24,2,.81,4.13.86,6.2,1.37a8.66,8.66,0,0,1,2.4.93,4.81,4.81,0,0,1,1,.75,6.25,6.25,0,0,1,.63.83c.25,6.2.52,12.39,1.2,18.56.39,3.53.93,7,1.67,10.52.36,1.72.81,3.42,1.31,5.11.3,1,.62,2,1,3A22,22,0,0,0,69,406.41C69.15,406.78,69.8,406.8,69.69,406.27Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.69,406.27c-.16-.76-.26-1.55-.48-2.29s-.51-1.68-.75-2.52c-.45-1.53-.84-3.08-1.19-4.64-.72-3.18-1.29-6.38-1.7-9.62-.83-6.5-1.13-13.06-1.4-19.6s-.56-13.15-1.25-19.69c-.42-4-1-7.9-1.69-11.82a20.72,20.72,0,0,1,2.51-5.6,47.1,47.1,0,0,0,3.85-7c0-.1-.06-.27-.13-.13-1.26,2.42-3.23,4.4-4.76,6.64a16.14,16.14,0,0,0-1.9,3.78c-.38-1.94-.78-3.88-1.22-5.8q-.42-1.81-.9-3.63c.1-.67.21-1.34.27-2a20.87,20.87,0,0,1,.36-2.48,24.61,24.61,0,0,1,1.52-4.73c1.26-3,3.42-5.58,4.41-8.69.05-.16-.14-.4-.23-.17a19.18,19.18,0,0,1-2.81,4.59,21.1,21.1,0,0,0-2.72,4.42,20.74,20.74,0,0,0-1.4,4.83c-.08.44-.15.88-.2,1.33a114.11,114.11,0,0,0-5.75-15.69c-.08-.17-.22.08-.19.18,1.71,5.63,3.31,11.29,4.72,17l-.31-.21a11.4,11.4,0,0,0-2.47-1.17c-2.21-.76-4.5-1.28-6.73-2-.13,0-.19.3-.07.34,2.07.72,4.14,1.48,6.19,2.24a19,19,0,0,1,2.41,1,7.28,7.28,0,0,1,1.09.75c.06,0,.12.12.18.18,1.07,4.44,2,8.91,2.77,13.41a10,10,0,0,0-5.61-3.06c-1.52-.31-3.08-.37-4.62-.58a14.23,14.23,0,0,1-4.31-1.35c-.08,0-.11.15-.06.2,2.11,1.93,5.54,2,8.21,2.45a10.89,10.89,0,0,1,4.14,1.41A8.78,8.78,0,0,1,60,339.13c.37,2.26.7,4.52,1,6.8.24,2.1.42,4.2.58,6.31a7.28,7.28,0,0,0-2.36-1.66,15.08,15.08,0,0,0-4.09-1.18c-2.86-.46-5.88-.56-8.33-2.3,0,0-.07.06,0,.08,2,2,4.88,2.48,7.56,3a23.5,23.5,0,0,1,4,1,9,9,0,0,1,1.76.88,18.86,18.86,0,0,1,1.61,1.35c.27,3.82.44,7.64.6,11.47a6,6,0,0,0-.82-.73,7.23,7.23,0,0,0-2.5-1.16c-2.23-.58-4.59-.25-6.78-1-.1,0-.15.2-.05.24,2,.81,4.13.86,6.2,1.37a8.66,8.66,0,0,1,2.4.93,4.81,4.81,0,0,1,1,.75,6.25,6.25,0,0,1,.63.83c.25,6.2.52,12.39,1.2,18.56.39,3.53.93,7,1.67,10.52.36,1.72.81,3.42,1.31,5.11.3,1,.62,2,1,3A22,22,0,0,0,69,406.41C69.15,406.78,69.8,406.8,69.69,406.27Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.47,407.62a20,20,0,0,1-3.07-7.11c-.54-2.15-.94-4.33-1.35-6.51a6.63,6.63,0,0,1,.34-1.38,14.94,14.94,0,0,1,.63-1.48l.37-.71a3.82,3.82,0,0,0,.3-1.1s0-.12-.08-.1c-.6.21-.91.82-1.22,1.33a8.57,8.57,0,0,0-.73,1.41c-.49-2.47-1-5-1.47-7.42h0c.08-.41.16-.81.28-1.21.25-.79.65-1.51,1-2.27a11.17,11.17,0,0,0,.76-2.51,7,7,0,0,0,.18-2.45c-.05-.22-.23,0-.21.15.14.9-.6,1.74-1,2.49s-.73,1.38-1.08,2.07c-.16.32-.32.65-.47,1a24.09,24.09,0,0,0-2-6.82,11.17,11.17,0,0,0-2.58-3.25,11.71,11.71,0,0,0-2-1.38,17.83,17.83,0,0,0-2.45-1c-.08,0-.13.17-.07.21.62.41,1.19.88,1.82,1.28a17.58,17.58,0,0,1,1.94,1.39,7.43,7.43,0,0,1,2.17,3,38.44,38.44,0,0,1,1.8,7.25,19.55,19.55,0,0,0-3.54-.6,11,11,0,0,1-3.68-1.05c-.15-.09-.22.26-.12.34a8.71,8.71,0,0,0,3.74,1.48c.67.13,1.34.26,2,.41s1.2.33,1.8.5c.54,2.85,1.11,5.69,1.67,8.52l.18.95a4.29,4.29,0,0,0-.48-.36,5.82,5.82,0,0,0-1.39-.69,2.54,2.54,0,0,0-.77-.18c-.24,0-.48,0-.72,0s-.19.35,0,.39a7.88,7.88,0,0,1,1.42.47,8.33,8.33,0,0,1,1.23.62,5.9,5.9,0,0,1,.92.73c.41,2.12.81,4.25,1.33,6.34a21.84,21.84,0,0,0,1.3,3.88,11.54,11.54,0,0,0,3.08,4C62.6,408.58,62.63,407.83,62.47,407.62Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.47,407.62a20,20,0,0,1-3.07-7.11c-.54-2.15-.94-4.33-1.35-6.51a6.63,6.63,0,0,1,.34-1.38,14.94,14.94,0,0,1,.63-1.48l.37-.71a3.82,3.82,0,0,0,.3-1.1s0-.12-.08-.1c-.6.21-.91.82-1.22,1.33a8.57,8.57,0,0,0-.73,1.41c-.49-2.47-1-5-1.47-7.42h0c.08-.41.16-.81.28-1.21.25-.79.65-1.51,1-2.27a11.17,11.17,0,0,0,.76-2.51,7,7,0,0,0,.18-2.45c-.05-.22-.23,0-.21.15.14.9-.6,1.74-1,2.49s-.73,1.38-1.08,2.07c-.16.32-.32.65-.47,1a24.09,24.09,0,0,0-2-6.82,11.17,11.17,0,0,0-2.58-3.25,11.71,11.71,0,0,0-2-1.38,17.83,17.83,0,0,0-2.45-1c-.08,0-.13.17-.07.21.62.41,1.19.88,1.82,1.28a17.58,17.58,0,0,1,1.94,1.39,7.43,7.43,0,0,1,2.17,3,38.44,38.44,0,0,1,1.8,7.25,19.55,19.55,0,0,0-3.54-.6,11,11,0,0,1-3.68-1.05c-.15-.09-.22.26-.12.34a8.71,8.71,0,0,0,3.74,1.48c.67.13,1.34.26,2,.41s1.2.33,1.8.5c.54,2.85,1.11,5.69,1.67,8.52l.18.95a4.29,4.29,0,0,0-.48-.36,5.82,5.82,0,0,0-1.39-.69,2.54,2.54,0,0,0-.77-.18c-.24,0-.48,0-.72,0s-.19.35,0,.39a7.88,7.88,0,0,1,1.42.47,8.33,8.33,0,0,1,1.23.62,5.9,5.9,0,0,1,.92.73c.41,2.12.81,4.25,1.33,6.34a21.84,21.84,0,0,0,1.3,3.88,11.54,11.54,0,0,0,3.08,4C62.6,408.58,62.63,407.83,62.47,407.62Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.62,324.49A69.07,69.07,0,0,0,90.49,328c-.44.24-.93.5-1.42.79l.12-.19a71.21,71.21,0,0,0,5.61-11.09,59.68,59.68,0,0,0,1.93-6,61.73,61.73,0,0,0,1.2-6.32c0-.26-.23-.44-.3-.13-.45,1.93-1.15,3.8-1.76,5.68s-1.28,3.66-2,5.44a82.42,82.42,0,0,1-5.1,10L88,327.5c0-.3,0-.59,0-.85a18.19,18.19,0,0,0-.33-3.53,20,20,0,0,0-.87-3.23,7.49,7.49,0,0,0-1.51-3c-.12-.11-.21.1-.2.2a22.29,22.29,0,0,0,1.08,2.95,18,18,0,0,1,.71,3.17,20.64,20.64,0,0,1,.17,3.24,21.08,21.08,0,0,0-.15,2.86c-1.39,2.3-2.77,4.6-4,7-.56,1.08-1.09,2.18-1.61,3.28,0-.05,0-.1,0-.15a20.25,20.25,0,0,0-1.34-3.65c-1.22-2.71-2.64-5.36-3.1-8.34,0-.15-.17,0-.16.07A23.23,23.23,0,0,0,78.44,335c.48,1.3.91,2.6,1.26,3.93a13.15,13.15,0,0,1,.37,2c0,.34.07.66.13,1-.06.14-.12.27-.17.4a3.44,3.44,0,0,0-.51,1.18c-.36.85-.7,1.69-1,2.55-1.2,3.1-2.24,6.25-3.15,9.44a19.8,19.8,0,0,0-.94-3.48,20.22,20.22,0,0,0-1.57-3.37,11.45,11.45,0,0,0-2.25-3.15c-.12-.1-.16.19-.14.25.49,1.09,1.22,2,1.69,3.15a32.54,32.54,0,0,1,1.22,3.24,48.17,48.17,0,0,1,1.31,5.83A125.85,125.85,0,0,0,72,370.94c-.69-1.69-1.57-3.28-2.41-4.91-.11-.22-.28.11-.22.25a34.55,34.55,0,0,1,2,6.18c.09.43.16.86.23,1.29-.6,4.69-1,9.42-1.12,14.14,0,.71.08,5,.17,7.68a43.31,43.31,0,0,0,.61,6.61,18.22,18.22,0,0,0,1,3.44c.23.5.77,1,1.27.77-.11-.82-.15-1.67-.33-2.48a59.52,59.52,0,0,1-1-11.06c0-1.19,0-2.38,0-3.57q.12-5.52.66-11a13.52,13.52,0,0,1,1.48-2.88c1.69-2.44,4.28-4,6-6.4.1-.13.06-.65-.2-.5a28.63,28.63,0,0,0-4,3,15.31,15.31,0,0,0-2.92,3c.27-2.14.58-4.28,1-6.41q.63-3.56,1.47-7.06c.32-.33.6-.7.88-1.05.38-.51.75-1,1.17-1.51a12,12,0,0,1,2.78-2.33,11.78,11.78,0,0,1,3-1.33c.5-.14,1-.27,1.52-.36a5.1,5.1,0,0,0,1.6-.36c.07,0,.1-.22,0-.26-1.08-.56-2.71-.26-3.84,0a12.27,12.27,0,0,0-3.56,1.44,11.87,11.87,0,0,0-2.68,2.27c.9-3.3,1.93-6.56,3.13-9.76q1.06-2.85,2.31-5.61a9.76,9.76,0,0,1,2.12-1.23,31.06,31.06,0,0,1,3.23-1,19.12,19.12,0,0,0,3-1.21c.12-.06.15-.4,0-.35-1.25.34-2.59.43-3.87.68a17,17,0,0,0-3.45,1c1.23-2.6,2.57-5.15,4-7.66a12.83,12.83,0,0,1,1.55-1.83,21,21,0,0,1,2.94-1.79,69.55,69.55,0,0,0,6.2-3.76C97.86,324.82,97.82,324.41,97.62,324.49Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.62,324.49A69.07,69.07,0,0,0,90.49,328c-.44.24-.93.5-1.42.79l.12-.19a71.21,71.21,0,0,0,5.61-11.09,59.68,59.68,0,0,0,1.93-6,61.73,61.73,0,0,0,1.2-6.32c0-.26-.23-.44-.3-.13-.45,1.93-1.15,3.8-1.76,5.68s-1.28,3.66-2,5.44a82.42,82.42,0,0,1-5.1,10L88,327.5c0-.3,0-.59,0-.85a18.19,18.19,0,0,0-.33-3.53,20,20,0,0,0-.87-3.23,7.49,7.49,0,0,0-1.51-3c-.12-.11-.21.1-.2.2a22.29,22.29,0,0,0,1.08,2.95,18,18,0,0,1,.71,3.17,20.64,20.64,0,0,1,.17,3.24,21.08,21.08,0,0,0-.15,2.86c-1.39,2.3-2.77,4.6-4,7-.56,1.08-1.09,2.18-1.61,3.28,0-.05,0-.1,0-.15a20.25,20.25,0,0,0-1.34-3.65c-1.22-2.71-2.64-5.36-3.1-8.34,0-.15-.17,0-.16.07A23.23,23.23,0,0,0,78.44,335c.48,1.3.91,2.6,1.26,3.93a13.15,13.15,0,0,1,.37,2c0,.34.07.66.13,1-.06.14-.12.27-.17.4a3.44,3.44,0,0,0-.51,1.18c-.36.85-.7,1.69-1,2.55-1.2,3.1-2.24,6.25-3.15,9.44a19.8,19.8,0,0,0-.94-3.48,20.22,20.22,0,0,0-1.57-3.37,11.45,11.45,0,0,0-2.25-3.15c-.12-.1-.16.19-.14.25.49,1.09,1.22,2,1.69,3.15a32.54,32.54,0,0,1,1.22,3.24,48.17,48.17,0,0,1,1.31,5.83A125.85,125.85,0,0,0,72,370.94c-.69-1.69-1.57-3.28-2.41-4.91-.11-.22-.28.11-.22.25a34.55,34.55,0,0,1,2,6.18c.09.43.16.86.23,1.29-.6,4.69-1,9.42-1.12,14.14,0,.71.08,5,.17,7.68a43.31,43.31,0,0,0,.61,6.61,18.22,18.22,0,0,0,1,3.44c.23.5.77,1,1.27.77-.11-.82-.15-1.67-.33-2.48a59.52,59.52,0,0,1-1-11.06c0-1.19,0-2.38,0-3.57q.12-5.52.66-11a13.52,13.52,0,0,1,1.48-2.88c1.69-2.44,4.28-4,6-6.4.1-.13.06-.65-.2-.5a28.63,28.63,0,0,0-4,3,15.31,15.31,0,0,0-2.92,3c.27-2.14.58-4.28,1-6.41q.63-3.56,1.47-7.06c.32-.33.6-.7.88-1.05.38-.51.75-1,1.17-1.51a12,12,0,0,1,2.78-2.33,11.78,11.78,0,0,1,3-1.33c.5-.14,1-.27,1.52-.36a5.1,5.1,0,0,0,1.6-.36c.07,0,.1-.22,0-.26-1.08-.56-2.71-.26-3.84,0a12.27,12.27,0,0,0-3.56,1.44,11.87,11.87,0,0,0-2.68,2.27c.9-3.3,1.93-6.56,3.13-9.76q1.06-2.85,2.31-5.61a9.76,9.76,0,0,1,2.12-1.23,31.06,31.06,0,0,1,3.23-1,19.12,19.12,0,0,0,3-1.21c.12-.06.15-.4,0-.35-1.25.34-2.59.43-3.87.68a17,17,0,0,0-3.45,1c1.23-2.6,2.57-5.15,4-7.66a12.83,12.83,0,0,1,1.55-1.83,21,21,0,0,1,2.94-1.79,69.55,69.55,0,0,0,6.2-3.76C97.86,324.82,97.82,324.41,97.62,324.49Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.57,380.17a7.37,7.37,0,0,0-3.84.08,18.38,18.38,0,0,0-4,1.19,10.38,10.38,0,0,0-2.25,1.38,24.59,24.59,0,0,1,3.54-5.6,28,28,0,0,1,5.67-5.37c.08-.05.09-.35,0-.29a20.9,20.9,0,0,0-5.78,3.73A21.32,21.32,0,0,0,79.57,381a23.47,23.47,0,0,0-1.33,3c-.06-.2-.12-.4-.19-.6a10.35,10.35,0,0,0-.83-1.79,5.75,5.75,0,0,0-.56-.83c-.13-.16-.31-.46-.55-.42,0,0-.07.08-.07.12a2.46,2.46,0,0,0,.36.89c.13.24.27.49.38.74a11.47,11.47,0,0,1,.61,1.54,15.83,15.83,0,0,1,.41,1.68c-.21.73-.4,1.47-.54,2.22a29.2,29.2,0,0,0-.48,4.38c-.12-.32-.25-.63-.39-.94a12.1,12.1,0,0,0-1.5-2.32c-.11-.15-.22.18-.14.28a12.35,12.35,0,0,1,1.83,4.89c0,.3.1.6.16.91,0,.49,0,1,0,1.48,0,1.8,0,3.6,0,5.4s-.25,3.44-.33,5.16c0,.27.43.8.63.4,1.23-2.48,1.23-5.51,1.25-8.22,0-1.67,0-3.34,0-5l.07,0a4.79,4.79,0,0,1,.89-.41,11.88,11.88,0,0,0,1.9-.83,12.17,12.17,0,0,0,3.22-2.47c.06-.07,0-.3-.07-.19a7.5,7.5,0,0,1-3.57,1.94c-.7.18-1.4.39-2.09.59l-.32.11c0-.77.07-1.55.14-2.32a24.11,24.11,0,0,1,.73-4c.55-.58,1-1.32,1.53-1.88a10.27,10.27,0,0,1,2.6-1.83,17.18,17.18,0,0,1,3.34-1.24l1.79-.48a5.11,5.11,0,0,1,2.06-.4C90.64,380.45,90.68,380.21,90.57,380.17Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.57,380.17a7.37,7.37,0,0,0-3.84.08,18.38,18.38,0,0,0-4,1.19,10.38,10.38,0,0,0-2.25,1.38,24.59,24.59,0,0,1,3.54-5.6,28,28,0,0,1,5.67-5.37c.08-.05.09-.35,0-.29a20.9,20.9,0,0,0-5.78,3.73A21.32,21.32,0,0,0,79.57,381a23.47,23.47,0,0,0-1.33,3c-.06-.2-.12-.4-.19-.6a10.35,10.35,0,0,0-.83-1.79,5.75,5.75,0,0,0-.56-.83c-.13-.16-.31-.46-.55-.42,0,0-.07.08-.07.12a2.46,2.46,0,0,0,.36.89c.13.24.27.49.38.74a11.47,11.47,0,0,1,.61,1.54,15.83,15.83,0,0,1,.41,1.68c-.21.73-.4,1.47-.54,2.22a29.2,29.2,0,0,0-.48,4.38c-.12-.32-.25-.63-.39-.94a12.1,12.1,0,0,0-1.5-2.32c-.11-.15-.22.18-.14.28a12.35,12.35,0,0,1,1.83,4.89c0,.3.1.6.16.91,0,.49,0,1,0,1.48,0,1.8,0,3.6,0,5.4s-.25,3.44-.33,5.16c0,.27.43.8.63.4,1.23-2.48,1.23-5.51,1.25-8.22,0-1.67,0-3.34,0-5l.07,0a4.79,4.79,0,0,1,.89-.41,11.88,11.88,0,0,0,1.9-.83,12.17,12.17,0,0,0,3.22-2.47c.06-.07,0-.3-.07-.19a7.5,7.5,0,0,1-3.57,1.94c-.7.18-1.4.39-2.09.59l-.32.11c0-.77.07-1.55.14-2.32a24.11,24.11,0,0,1,.73-4c.55-.58,1-1.32,1.53-1.88a10.27,10.27,0,0,1,2.6-1.83,17.18,17.18,0,0,1,3.34-1.24l1.79-.48a5.11,5.11,0,0,1,2.06-.4C90.64,380.45,90.68,380.21,90.57,380.17Z",
    style: {
      opacity: 0.45
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Padlock--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--padlock--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--padlock--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.25,253.8c0-1.69-1.11-3.37-3.34-4.66l-6.58-3.8c-4.46-2.58-11.69-2.58-16.16,0l-59.62,34.42c-2.23,1.29-3.35,3-3.34,4.67h0v78.75h0c0,1.69,1.11,3.39,3.34,4.68l6.58,3.79c4.46,2.58,11.69,2.58,16.15,0l59.63-34.42c2.23-1.29,3.34-3,3.34-4.66h0V253.8Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.13,292.89l-6.58-3.8c-4.46-2.57-4.46-6.75,0-9.33l59.62-34.42c4.47-2.58,11.7-2.58,16.16,0l6.58,3.8c4.46,2.57,4.46,6.75,0,9.33l-59.63,34.42C286.82,295.46,279.59,295.46,275.13,292.89Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.22,294.82v78.76a16.45,16.45,0,0,1-8.08-1.92l-6.59-3.81c-2.24-1.28-3.36-3-3.34-4.68V284.43c0,1.69,1.1,3.37,3.34,4.66l6.59,3.81A16.56,16.56,0,0,0,283.22,294.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.6,333.78,312.37,342l2.2-25.76c-1.7-.9-2.78-3.11-2.78-6.29,0-5.67,3.44-12.26,7.7-14.72s7.7.16,7.7,5.83a19.37,19.37,0,0,1-2.79,9.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.6 333.78 313.71 326.33 312.37 342 326.6 333.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.49,295.23c-2.79,1.61-5.22,5-6.57,8.72l11.48,6.62h0a19.37,19.37,0,0,0,2.79-9.51C327.19,295.39,323.74,292.78,319.49,295.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.14,257.53V224.06c0-9.75-3.68-17.48-10.11-21.19-6.13-3.54-13.72-3.06-21.36,1.35-14,8.11-25,27.88-25,45v31.67h0a3.2,3.2,0,0,0,1.9,2.62,10,10,0,0,0,9.1,0,3.18,3.18,0,0,0,1.89-2.62h0V249.24c0-12.53,8.52-28,18.59-33.86,3.44-2,6.53-2.47,8.48-1.35,2.29,1.33,3.67,5.08,3.67,10v33.47h0v0h0a3.21,3.21,0,0,0,1.89,2.61,10.06,10.06,0,0,0,9.1,0,3.21,3.21,0,0,0,1.89-2.61h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.16,201.53a16.5,16.5,0,0,1,8.37,2.21c6.11,3.53,9.61,10.93,9.61,20.32v33.48a2.32,2.32,0,0,1-1.39,1.75,9,9,0,0,1-8.1,0,2.32,2.32,0,0,1-1.39-1.75V224.06c0-5.39-1.52-9.36-4.17-10.89a5.88,5.88,0,0,0-3-.73,13.58,13.58,0,0,0-6.52,2.08c-10.35,6-19.09,21.88-19.09,34.72v31.67c0,.61-.5,1.25-1.39,1.76a9.11,9.11,0,0,1-8.1,0,2.36,2.36,0,0,1-1.39-1.7V249.24c0-16.81,10.77-36.21,24.53-44.15a24.08,24.08,0,0,1,12-3.56h0m0-1a25.12,25.12,0,0,0-12.49,3.69c-14,8.11-25,27.88-25,45v31.67h0a3.2,3.2,0,0,0,1.9,2.62,10,10,0,0,0,9.1,0,3.18,3.18,0,0,0,1.89-2.62h0V249.24c0-12.53,8.52-28,18.59-33.86a12.62,12.62,0,0,1,6-1.94,5,5,0,0,1,2.46.59c2.29,1.33,3.67,5.08,3.67,10v33.47h0v0h0a3.21,3.21,0,0,0,1.89,2.61,10,10,0,0,0,9.1,0,3.21,3.21,0,0,0,1.89-2.61h0V224.06c0-9.75-3.68-17.48-10.11-21.19a17.59,17.59,0,0,0-8.87-2.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.56,201.61q-1,.48-2,1.08c-14,8.1-25,27.89-25,45v31.65a3.18,3.18,0,0,0,1.89,2.63,9.7,9.7,0,0,0,6,1,4,4,0,0,1-.76.55,10,10,0,0,1-9.11,0,3.15,3.15,0,0,1-1.89-2.63V249.24c0-17.14,11-36.92,25-45A27.53,27.53,0,0,1,312.56,201.61Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.55,360.65V58.1c0-7.79-3.87-9.93-7.31-11.92s-9.08-3.18-14-.36L113.34,118c-4.88,2.82-8.83,9.67-8.83,15.3V435.81c0,5.63,3.53,8.95,7,10.94s9.42,4.15,14.3,1.34L250.71,376A16.6,16.6,0,0,0,259.55,360.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.6,363.52,123.13,437.69l0-303.86-16.08-9.28a18,18,0,0,0-2.58,8.7V435.81c0,5.63,3.53,8.95,7,10.94s9.42,4.15,14.3,1.34L250.71,376a16.85,16.85,0,0,0,7.65-8.53l-.5-.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.48,55.48l-125.3,72.35a13.72,13.72,0,0,0-6.2,10.73V438.65c0,6.05,4.3,8.53,9.54,5.5l122-70.41a15.62,15.62,0,0,0,7-12.17v-302C257.51,55.07,254.34,53.25,250.48,55.48Z",
    style: {
      fill: "#455a64"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.39,73.88V354.4A14.78,14.78,0,0,1,244.72,366L131.77,431.19c-3.69,2.14-6.68.42-6.68-3.85V144.76a14.89,14.89,0,0,1,4.69-10.06c.21-.19.41-.39.63-.57a11.71,11.71,0,0,1,1.36-.93l31.77-18.34,2.07-1.2c1.14-.66,2.07-.13,2.07,1.2s1,1.82,2.21,1.11l37-21.38a4.75,4.75,0,0,0,2.21-3.66A4.72,4.72,0,0,1,211,87.46l.21-.13,31.08-17.94.66-.38C247.6,66.32,251.39,68.52,251.39,73.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235,358.48a14.78,14.78,0,0,0,6.67-11.57V69.73l-30.5,17.6-.21.13a4.72,4.72,0,0,0-1.86,3.47,4.75,4.75,0,0,1-2.21,3.66l-37,21.38c-1.22.71-2.21.2-2.21-1.11s-.93-1.86-2.07-1.2l-2.07,1.2L131.77,133.2a11.71,11.71,0,0,0-1.36.93c-.22.18-.42.38-.63.57a14.89,14.89,0,0,0-4.69,10.06V422Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51,104.68l17-9.8c1-.59,1.83-.17,1.83.93a3.93,3.93,0,0,1-1.83,3l-17,9.8c-1,.58-1.83.17-1.83-.93A3.93,3.93,0,0,1,175.51,104.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.2,89c1.14-.65,2.06-.12,2.06,1.2a4.55,4.55,0,0,1-2.06,3.57c-1.14.66-2.07.13-2.07-1.19A4.59,4.59,0,0,1,201.2,89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.1,169.55a7.47,7.47,0,0,0-3.27-5.9,2.15,2.15,0,0,0-2.24-.19c-.41.25-2,1.15-2.45,1.4a2.56,2.56,0,0,0-1,2.32v24.65a7.48,7.48,0,0,0,3.26,5.91,2.22,2.22,0,0,0,2.16.23c.45-.24,2.1-1.19,2.52-1.45a2.53,2.53,0,0,0,1-2.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.67,171V195.6c0,2.22-1.47,3.18-3.27,2.14a7.48,7.48,0,0,1-3.26-5.91V167.18c0-2.22,1.46-3.18,3.26-2.13A7.47,7.47,0,0,1,113.67,171Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.1,212.7a7.49,7.49,0,0,0-3.27-5.91,2.17,2.17,0,0,0-2.24-.18c-.41.25-2,1.14-2.45,1.4a2.56,2.56,0,0,0-1,2.32V235a7.49,7.49,0,0,0,3.26,5.91,2.22,2.22,0,0,0,2.16.23c.45-.24,2.1-1.19,2.52-1.45a2.54,2.54,0,0,0,1-2.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.67,214.1v24.65c0,2.22-1.47,3.18-3.27,2.14a7.49,7.49,0,0,1-3.26-5.91V210.33c0-2.22,1.46-3.18,3.26-2.14A7.5,7.5,0,0,1,113.67,214.1Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218,393.41v-15.1a1.25,1.25,0,0,1,.56-1l36.08-20.82c.31-.18.56,0,.56.33v15.09a1.22,1.22,0,0,1-.56,1l-36.08,20.82C218.25,393.91,218,393.77,218,393.41Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.6,357.66l-36.08,20.82a1.23,1.23,0,0,0-.56,1v15.09a1.23,1.23,0,0,0,.56,1l2,1.12a1.23,1.23,0,0,0,1.12,0l36.08-20.82a1.25,1.25,0,0,0,.56-1v-15.1a1.19,1.19,0,0,0-.57-1l-2-1.13A1.23,1.23,0,0,0,256.6,357.66Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09,396.3V381.21a1.23,1.23,0,0,1,.56-1l36.08-20.82c.31-.18.56,0,.56.32v15.1a1.25,1.25,0,0,1-.56,1l-36.08,20.82C223.34,396.81,223.09,396.66,223.09,396.3Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,396.63a1.28,1.28,0,0,1-1.13,0l-2-1.12a1.24,1.24,0,0,1-.57-1v-15.1a1.19,1.19,0,0,1,.18-.58l3.12,1.79a1.12,1.12,0,0,0-.16.55V396.3C223.09,396.63,223.32,396.82,223.65,396.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.28,359.64c0-.28-.27-.38-.55-.22l-36.08,20.82a1.08,1.08,0,0,0-.4.42l-3.12-1.79a1.12,1.12,0,0,1,.39-.39l36.08-20.83a1.26,1.26,0,0,1,1.12,0l2,1.12A1.22,1.22,0,0,1,260.28,359.64Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.53,381.07c.09-.06.15-.06.2,0a.7.7,0,0,1,.12.26l2.09,7.09v.08a.72.72,0,0,1-.06.29.43.43,0,0,1-.17.2l-.61.35q-.16.1-.24,0a.51.51,0,0,1-.09-.16L229.4,388l-2.69,1.56-.36,1.67a1.55,1.55,0,0,1-.1.27.47.47,0,0,1-.24.24l-.61.36a.13.13,0,0,1-.16,0,.28.28,0,0,1-.07-.21.31.31,0,0,1,0-.1l2.09-9.49a2,2,0,0,1,.11-.4.52.52,0,0,1,.21-.23Zm.46,5.48-.93-3.19-.94,4.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.26,383.44a.66.66,0,0,1,.09-.3.41.41,0,0,1,.16-.18l.69-.4a.15.15,0,0,1,.17,0,.24.24,0,0,1,.06.21,7.62,7.62,0,0,1-.17,1.18,5.8,5.8,0,0,1-1.24,2.39,4.5,4.5,0,0,1-1.13.93,2.19,2.19,0,0,1-1,.33,1.11,1.11,0,0,1-.76-.31,1.83,1.83,0,0,1-.49-.86,5.09,5.09,0,0,1-.21-1.34c0-.32,0-.69,0-1.09s0-.77,0-1.11a8.13,8.13,0,0,1,.21-1.57,6.34,6.34,0,0,1,.49-1.43,5.37,5.37,0,0,1,.76-1.19,3.74,3.74,0,0,1,1-.87,2.21,2.21,0,0,1,1.13-.38,1.18,1.18,0,0,1,.78.26,1.57,1.57,0,0,1,.46.71,4.37,4.37,0,0,1,.17,1,.58.58,0,0,1-.06.29.5.5,0,0,1-.17.2l-.69.4a.15.15,0,0,1-.16,0s-.08-.09-.1-.2a1.07,1.07,0,0,0-.12-.44.68.68,0,0,0-.25-.3.6.6,0,0,0-.41-.08,1.37,1.37,0,0,0-.58.21,2.08,2.08,0,0,0-.58.49,3.18,3.18,0,0,0-.41.66,3.48,3.48,0,0,0-.26.77,4.81,4.81,0,0,0-.1.84c0,.34,0,.71,0,1.11s0,.76,0,1.09a3.05,3.05,0,0,0,.1.72,1.05,1.05,0,0,0,.26.47.59.59,0,0,0,.41.19,1,1,0,0,0,.58-.18,2.4,2.4,0,0,0,.58-.46,3,3,0,0,0,.67-1.16A2.07,2.07,0,0,0,235.26,383.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.09,380.08a.75.75,0,0,1,.09-.31.44.44,0,0,1,.16-.17l.69-.4a.12.12,0,0,1,.16,0,.26.26,0,0,1,.07.22,6.64,6.64,0,0,1-.18,1.18,5.6,5.6,0,0,1-.46,1.23,5.7,5.7,0,0,1-.77,1.16,4.26,4.26,0,0,1-1.13.92,2.11,2.11,0,0,1-1,.34,1.13,1.13,0,0,1-.77-.31,2,2,0,0,1-.49-.86,6.18,6.18,0,0,1-.21-1.34c0-.33,0-.69,0-1.09s0-.77,0-1.11a10.19,10.19,0,0,1,.21-1.58,7.08,7.08,0,0,1,.49-1.43,5.65,5.65,0,0,1,.77-1.19,4.12,4.12,0,0,1,1-.87,2.28,2.28,0,0,1,1.13-.37,1.11,1.11,0,0,1,.77.26,1.44,1.44,0,0,1,.46.71,3.79,3.79,0,0,1,.18,1,.59.59,0,0,1-.07.29.45.45,0,0,1-.16.19l-.69.4a.17.17,0,0,1-.17,0s-.08-.09-.09-.2a1.42,1.42,0,0,0-.12-.44.75.75,0,0,0-.25-.3.68.68,0,0,0-.41-.09,1.33,1.33,0,0,0-.58.21,2.1,2.1,0,0,0-.58.49,3.22,3.22,0,0,0-.42.66,3.75,3.75,0,0,0-.25.78,4.85,4.85,0,0,0-.11.83c0,.34,0,.71,0,1.12s0,.76,0,1.09a3,3,0,0,0,.11.72,1.1,1.1,0,0,0,.25.47.64.64,0,0,0,.42.18,1.07,1.07,0,0,0,.58-.18,2.57,2.57,0,0,0,.58-.45,3.48,3.48,0,0,0,.41-.56,3.11,3.11,0,0,0,.26-.6A3.33,3.33,0,0,0,241.09,380.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.22,377.81a.13.13,0,0,1,.16,0,.28.28,0,0,1,.07.21V379a.58.58,0,0,1-.07.28.37.37,0,0,1-.16.2l-3.74,2.16a.12.12,0,0,1-.16,0,.28.28,0,0,1-.07-.21v-8.47a.62.62,0,0,1,.07-.29.42.42,0,0,1,.16-.2l3.67-2.12a.13.13,0,0,1,.16,0,.28.28,0,0,1,.07.21v.93a.59.59,0,0,1-.07.29.42.42,0,0,1-.16.2l-2.75,1.59v2.08l2.56-1.48a.13.13,0,0,1,.17,0,.28.28,0,0,1,.06.2v.94a.71.71,0,0,1-.06.28.39.39,0,0,1-.17.2l-2.56,1.48v2.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,368.08c.69-.4,1.22-.46,1.6-.18s.57.9.57,1.86a5.36,5.36,0,0,1-.57,2.53A4.08,4.08,0,0,1,251,374l-1.36.79v2.92a.77.77,0,0,1-.07.29.48.48,0,0,1-.16.2l-.69.4a.13.13,0,0,1-.17,0,.28.28,0,0,1-.06-.2v-8.48a.71.71,0,0,1,.06-.28.39.39,0,0,1,.17-.2Zm-1.36,5.05,1.32-.76a2.08,2.08,0,0,0,1.06-1.94c0-.49-.1-.78-.29-.85a.92.92,0,0,0-.77.16l-1.32.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.09,364a.12.12,0,0,1,.16,0,.25.25,0,0,1,.07.21v.93a.62.62,0,0,1-.07.29.48.48,0,0,1-.16.2l-1.53.88v7.19a.82.82,0,0,1-.07.29.4.4,0,0,1-.17.19l-.68.4a.12.12,0,0,1-.17,0,.29.29,0,0,1-.07-.21v-7.18l-1.53.88a.12.12,0,0,1-.16,0,.25.25,0,0,1-.07-.21v-.93a.62.62,0,0,1,.07-.29.48.48,0,0,1,.16-.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156,429.18V414.09a1.22,1.22,0,0,1,.56-1l36.08-20.82c.31-.18.56,0,.56.32v15.1a1.25,1.25,0,0,1-.56,1l-36.08,20.82C156.28,429.69,156,429.54,156,429.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,421.85a.13.13,0,0,1-.16,0,.28.28,0,0,1-.07-.21v-8.47a.59.59,0,0,1,.07-.29.37.37,0,0,1,.16-.2l2.51-1.45a1.56,1.56,0,0,1,.91-.27.89.89,0,0,1,.59.3,1.46,1.46,0,0,1,.32.66,3,3,0,0,1,.1.78,3.45,3.45,0,0,1-.07.74,4.44,4.44,0,0,1-.16.63c-.07.18-.14.34-.2.47s-.12.23-.16.29a1.18,1.18,0,0,1,.49.5,2.29,2.29,0,0,1,.22,1.15,5.14,5.14,0,0,1-.12,1.06,5.92,5.92,0,0,1-.35,1.08,4.26,4.26,0,0,1-.57,1,2.64,2.64,0,0,1-.8.7Zm3.28-8.43c0-.33-.07-.54-.2-.63s-.36-.05-.65.12l-1.51.87v2l1.51-.88a1.77,1.77,0,0,0,.65-.62A1.87,1.87,0,0,0,167.45,413.42Zm-2.36,6.26,1.58-.91a1.66,1.66,0,0,0,.68-.71,2,2,0,0,0,.22-.93.84.84,0,0,0-.23-.68c-.15-.12-.37-.1-.67.08l-1.58.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.49,407.86q.13-.08.21,0a.79.79,0,0,1,.12.26l2.08,7.09a.19.19,0,0,1,0,.08.62.62,0,0,1-.07.29.42.42,0,0,1-.16.2l-.61.35q-.18.11-.24,0a.29.29,0,0,1-.09-.16l-.37-1.25-2.69,1.56-.37,1.66a1.22,1.22,0,0,1-.09.27.53.53,0,0,1-.24.25l-.61.36a.15.15,0,0,1-.17,0,.33.33,0,0,1-.06-.21v-.1l2.09-9.49a3.58,3.58,0,0,1,.12-.41.45.45,0,0,1,.21-.22Zm.47,5.49-.94-3.2-.93,4.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.23,410.24a.75.75,0,0,1,.09-.31.44.44,0,0,1,.16-.17l.69-.4a.13.13,0,0,1,.16,0,.26.26,0,0,1,.07.22,6.64,6.64,0,0,1-.18,1.18,6.1,6.1,0,0,1-.45,1.23,6.2,6.2,0,0,1-.78,1.16,4.5,4.5,0,0,1-1.13.93,2.19,2.19,0,0,1-1,.33,1.13,1.13,0,0,1-.77-.31,2,2,0,0,1-.49-.86,6.18,6.18,0,0,1-.21-1.34c0-.32,0-.69,0-1.09s0-.77,0-1.11a10.35,10.35,0,0,1,.21-1.58,7.08,7.08,0,0,1,.49-1.43,5.65,5.65,0,0,1,.77-1.19,4.12,4.12,0,0,1,1-.87,2.28,2.28,0,0,1,1.13-.37,1.2,1.2,0,0,1,.78.26,1.55,1.55,0,0,1,.45.71,3.87,3.87,0,0,1,.18,1,.59.59,0,0,1-.07.29.56.56,0,0,1-.16.2l-.69.39a.15.15,0,0,1-.17,0c-.05,0-.08-.09-.09-.2a1.5,1.5,0,0,0-.12-.44.75.75,0,0,0-.25-.3.68.68,0,0,0-.41-.09,1.65,1.65,0,0,0-.58.21,2.14,2.14,0,0,0-.58.5,3,3,0,0,0-.41.65,3.76,3.76,0,0,0-.26.78,4.83,4.83,0,0,0-.11.84c0,.34,0,.71,0,1.11s0,.76,0,1.09a3,3,0,0,0,.11.72,1.11,1.11,0,0,0,.26.47.6.6,0,0,0,.41.18,1.13,1.13,0,0,0,.58-.17,2.61,2.61,0,0,0,.58-.46,3.48,3.48,0,0,0,.41-.56,3.11,3.11,0,0,0,.26-.6A3.15,3.15,0,0,0,179.23,410.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.92,408.74a.41.41,0,0,1,.05.09v.07a.72.72,0,0,1-.06.29.39.39,0,0,1-.17.2l-.8.47c-.12.06-.21.07-.28,0l-.12-.1-2-2.32v3.43a.58.58,0,0,1-.07.28.37.37,0,0,1-.16.2l-.69.4a.12.12,0,0,1-.16,0,.25.25,0,0,1-.07-.21v-8.47a.62.62,0,0,1,.07-.29.56.56,0,0,1,.16-.2l.69-.39a.11.11,0,0,1,.16,0,.25.25,0,0,1,.07.21v3.08l1.86-4.22a1.39,1.39,0,0,1,.16-.3.63.63,0,0,1,.22-.21l.79-.45a.11.11,0,0,1,.16,0,.29.29,0,0,1,.07.21.49.49,0,0,1-.06.22l-2.29,5.17Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.87,75.15c-1.6-.92-3.8-.79-6.23.61l-.69.4L227.41,94.94l-.22.14a4.92,4.92,0,0,0-1.95,3.63,5,5,0,0,1-2.31,3.83l-38.76,22.38-.09,0a1.5,1.5,0,0,0-.63-1.32c-.39-.22-1.84-1.07-2.24-1.29a1.5,1.5,0,0,0-1.53.16l-2.17,1.25L144.26,143a12,12,0,0,0-1.43,1l-.66.6a15.62,15.62,0,0,0-4.9,10.53V449c0,2.23.78,3.79,2,4.52l2.25,1.3c1.27.73,3,.62,4.93-.5L264.74,386a15.48,15.48,0,0,0,7-12.11V82.15c0-2.8-1-4.77-2.58-5.7Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,453.34v.58l-.67.38c-1.92,1.12-3.66,1.22-4.93.5l-2.25-1.3c-1.26-.74-2-2.29-2-4.52V155.06a14.52,14.52,0,0,1,2.41-7.46l2.67,1.53a14.18,14.18,0,0,0-2.34,7.22V450.27a5.36,5.36,0,0,0,1,3.37,3,3,0,0,0,2.4,1.13,5.89,5.89,0,0,0,2.88-.9Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.79,97.74A4.08,4.08,0,0,0,228,100a5,5,0,0,1-.86,2.6l-2.69-1.55a4.45,4.45,0,0,0,.82-2.34,4.73,4.73,0,0,1,.87-2.52Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.37,454.77a3,3,0,0,1-2.4-1.12,5.41,5.41,0,0,1-1-3.38V156.35a15.22,15.22,0,0,1,4.74-10.17L145,146l.44-.39a11,11,0,0,1,1.34-.92L180,125.48s1-.57,2.17-1.25a1.5,1.5,0,0,1,.72-.23c.63,0,.7.73.7,1a1.78,1.78,0,0,0,1.73,2,2.72,2.72,0,0,0,1.34-.41l38.75-22.37A5.46,5.46,0,0,0,228,100a4.39,4.39,0,0,1,1.73-3.22l.19-.12,32.53-18.77.7-.41a7.57,7.57,0,0,1,3.68-1.13c2.72,0,4.42,2.22,4.42,5.8V373.92a14.91,14.91,0,0,1-6.74,11.68L146.25,453.87A5.89,5.89,0,0,1,143.37,454.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.81,76.35a7.57,7.57,0,0,0-3.68,1.13l-.7.41L229.9,96.67a.87.87,0,0,0-.18.11A4.37,4.37,0,0,0,228,100a5.45,5.45,0,0,1-2.56,4.27l-38.76,22.37a2.69,2.69,0,0,1-1.34.41,1.78,1.78,0,0,1-1.73-2c0-.32-.07-1-.7-1a1.5,1.5,0,0,0-.72.23L180,125.48l-33.26,19.2a11,11,0,0,0-1.34.92L145,146l-.21.2A15.18,15.18,0,0,0,140,156.35V174L271.23,98.17v-16C271.23,78.57,269.54,76.35,266.81,76.35Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.81,76.35a7.57,7.57,0,0,0-3.68,1.13l-.7.41L229.9,96.67a.87.87,0,0,0-.18.11A4.37,4.37,0,0,0,228,100a5.45,5.45,0,0,1-2.56,4.27l-38.76,22.37a2.69,2.69,0,0,1-1.34.41,1.78,1.78,0,0,1-1.73-2c0-.32-.07-1-.7-1a1.5,1.5,0,0,0-.72.23L180,125.48l-33.26,19.2a11,11,0,0,0-1.34.92L145,146l-.21.2A15.18,15.18,0,0,0,140,156.35V174L271.23,98.17v-16C271.23,78.57,269.54,76.35,266.81,76.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.47,156.45a.49.49,0,0,1-.05.2.58.58,0,0,1-.12.14l-.27.15q-.08,0-.12,0a.14.14,0,0,1-.06-.13V152l-1,1.67a.27.27,0,0,1-.13.13s-.08,0-.11,0l-.16-.18a.22.22,0,0,1,0-.15.48.48,0,0,1,.07-.2l1.39-2.22a.65.65,0,0,1,.11-.12l.1-.07.27-.15a.09.09,0,0,1,.12,0,.16.16,0,0,1,.05.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2,154.87a.37.37,0,0,1,0,.2.33.33,0,0,1-.12.14l-.27.15s-.09,0-.12,0,0-.07,0-.13v-4.77l-1.05,1.67a.32.32,0,0,1-.13.13.1.1,0,0,1-.12,0l-.16-.18a.17.17,0,0,1,0-.15.51.51,0,0,1,.06-.2l1.39-2.22a.65.65,0,0,1,.11-.12l.1-.07.27-.15q.08,0,.12,0s0,.07,0,.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.74,150.15a.11.11,0,0,1,.12,0,.18.18,0,0,1,0,.14v.58a.45.45,0,0,1,0,.19.35.35,0,0,1-.12.14l-.44.25a.11.11,0,0,1-.12,0,.16.16,0,0,1-.05-.14v-.58a.34.34,0,0,1,.05-.19.24.24,0,0,1,.12-.14Zm0,3a.11.11,0,0,1,.12,0,.18.18,0,0,1,0,.14v.58a.45.45,0,0,1,0,.19.35.35,0,0,1-.12.14l-.44.25a.11.11,0,0,1-.12,0s-.05-.07-.05-.14v-.58a.34.34,0,0,1,.05-.19.24.24,0,0,1,.12-.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.24,151.78a.52.52,0,0,0,.37.43.9.9,0,0,0,.66-.14,2.06,2.06,0,0,0,.41-.32,1.94,1.94,0,0,0,.32-.42,2.22,2.22,0,0,0,.23-.52,2.35,2.35,0,0,0,.08-.6,1.41,1.41,0,0,0-.08-.5.52.52,0,0,0-.23-.27.49.49,0,0,0-.32,0,1.29,1.29,0,0,0-.41.15,1.83,1.83,0,0,0-.39.31,1.93,1.93,0,0,0-.24.29l-.17.25a.59.59,0,0,1-.17.18l-.33.19a.09.09,0,0,1-.1,0,.12.12,0,0,1,0-.11l.19-3a.49.49,0,0,1,0-.19.36.36,0,0,1,.13-.14l2.29-1.32s.09,0,.12,0,0,.07,0,.13v.31a.39.39,0,0,1,0,.2.33.33,0,0,1-.12.14l-1.89,1.09-.11,1.55c.08-.08.18-.19.31-.3a2.28,2.28,0,0,1,.47-.34,1.66,1.66,0,0,1,.64-.23.78.78,0,0,1,.53.09.88.88,0,0,1,.35.44,1.92,1.92,0,0,1,.13.78,3.15,3.15,0,0,1-.13.92,3.38,3.38,0,0,1-.35.85,3.75,3.75,0,0,1-.53.71,2.71,2.71,0,0,1-.64.5,1.66,1.66,0,0,1-.62.24,1,1,0,0,1-.52,0,.84.84,0,0,1-.36-.32,1.25,1.25,0,0,1-.14-.59.34.34,0,0,1,0-.16.36.36,0,0,1,.1-.11l.3-.17a.1.1,0,0,1,.1,0A.13.13,0,0,1,155.24,151.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.09,149.67a.92.92,0,0,0,.09.23.34.34,0,0,0,.17.14.54.54,0,0,0,.31,0,2.31,2.31,0,0,0,.88-.5,2.37,2.37,0,0,0,.32-.39,1.82,1.82,0,0,0,.21-.47,1.51,1.51,0,0,0,.09-.53,1,1,0,0,0-.08-.43.35.35,0,0,0-.21-.19.59.59,0,0,0-.32,0,2.2,2.2,0,0,0-.39.18l-.54.31a.1.1,0,0,1-.13,0,.16.16,0,0,1-.05-.13v-.31a.35.35,0,0,1,0-.17.69.69,0,0,1,.07-.15l1.17-2.36L158.85,146a.1.1,0,0,1-.13,0,.16.16,0,0,1-.05-.13v-.31a.49.49,0,0,1,.05-.2.44.44,0,0,1,.13-.14l2.55-1.47a.12.12,0,0,1,.13,0,.2.2,0,0,1,.05.14v.31a.55.55,0,0,1,0,.17,1.63,1.63,0,0,1-.09.19l-1.15,2.32a1.66,1.66,0,0,1,.6-.21.7.7,0,0,1,.46.09.84.84,0,0,1,.3.38,1.86,1.86,0,0,1,.1.67,2.91,2.91,0,0,1-.13.87,3.27,3.27,0,0,1-.86,1.45,2.57,2.57,0,0,1-.62.49,2.16,2.16,0,0,1-.75.3.94.94,0,0,1-.52-.05.69.69,0,0,1-.31-.32,1.12,1.12,0,0,1-.1-.5.34.34,0,0,1,0-.16.27.27,0,0,1,.1-.11l.3-.17a.09.09,0,0,1,.11,0A.15.15,0,0,1,159.09,149.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.22,139.47h0m0,0-2,6.83v-3L165,144.62l4.23-5.15m0-.5h0a.44.44,0,0,0-.25.08.41.41,0,0,0-.1.09h0l-4.22,5.14a.51.51,0,0,0,.39.83.57.57,0,0,0,.25-.06l1.47-.85v2.09a.5.5,0,0,0,.43.5h.08a.5.5,0,0,0,.48-.37l2-6.78a.41.41,0,0,0,0-.19.5.5,0,0,0-.51-.5Zm0,1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.64 105.14 237.55 105.77 237.55 103.64 238.64 103.01 238.64 105.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.36 104.14 239.28 104.77 239.28 101.73 240.36 101.1 240.36 104.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.09 103.15 241 103.78 241 99.58 242.09 98.95 242.09 103.15",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.81 102.15 242.72 102.78 242.72 97.47 243.81 96.85 243.81 102.15",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.38,92.33a8.18,8.18,0,0,0-2.87,3.22l.72.57a5.93,5.93,0,0,1,2.15-2.41,1.94,1.94,0,0,1,2.17-.08l.72-1.4A2.6,2.6,0,0,0,251.38,92.33Zm-1.87,4,.65.52a3.5,3.5,0,0,1,1.22-1.37,1.1,1.1,0,0,1,1.23,0l.66-1.29a1.68,1.68,0,0,0-1.89.07A5.19,5.19,0,0,0,249.51,96.35Zm1,.77.91.73.92-1.8a.82.82,0,0,0-.92,0A2.5,2.5,0,0,0,250.47,97.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5,84.9c.39-.22.71,0,.71.53v3.43a1.7,1.7,0,0,1-.71,1.35l-6.11,3.53c-.39.22-.71,0-.71-.54V89.78a1.69,1.69,0,0,1,.71-1.35l6.11-3.53m0-.29-6.11,3.53a2.2,2.2,0,0,0-.93,1.76v3.43c0,.68.42,1,.93.7l6.11-3.53a2.24,2.24,0,0,0,.93-1.77V85.31c0-.68-.42-1-.93-.7Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,90.78l-3.45,2c-.15.09-.28,0-.28-.22V89.72a.71.71,0,0,1,.28-.55l3.45-2c.15-.09.28,0,.28.22v2.84A.69.69,0,0,1,262,90.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.08,87.57l-.24.14V85.86l.24-.14c.14-.08.25.27.25.78S266.22,87.49,266.08,87.57Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.81,76.84h0c2.45,0,3.92,2,3.92,5.31V373.92a14.55,14.55,0,0,1-6.49,11.25L146,453.44a5.41,5.41,0,0,1-2.62.83c-1.8,0-2.87-1.49-2.87-4V156.35a14.66,14.66,0,0,1,4.58-9.79l.22-.21.39-.35a11.15,11.15,0,0,1,1.3-.89l33.26-19.2s1-.57,2.17-1.25a1,1,0,0,1,.47-.17c.2,0,.2.5.2.56a2.27,2.27,0,0,0,2.23,2.49,3.16,3.16,0,0,0,1.58-.47l38.77-22.37a6,6,0,0,0,2.81-4.7A3.93,3.93,0,0,1,230,97.18l.15-.09,32.54-18.78.69-.4a7,7,0,0,1,3.43-1.07m0-1a8,8,0,0,0-3.93,1.2l-.7.4L229.65,96.23l-.22.14a4.92,4.92,0,0,0-2,3.63,5,5,0,0,1-2.31,3.84l-38.76,22.37a2.24,2.24,0,0,1-1.09.34c-.73,0-1.23-.55-1.23-1.5s-.49-1.55-1.2-1.55a1.9,1.9,0,0,0-1,.3l-2.17,1.25-33.26,19.2a12.76,12.76,0,0,0-1.42,1l-.66.6a15.62,15.62,0,0,0-4.9,10.53V450.27c0,3.17,1.57,5,3.86,5a6.23,6.23,0,0,0,3.12-1L264.74,386a15.48,15.48,0,0,0,7-12.11V82.15c0-4-2-6.3-4.91-6.3Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.67,176.33c.93-.54,1.66-.62,2.18-.24s.77,1.23.77,2.53a7.43,7.43,0,0,1-.77,3.45,5.63,5.63,0,0,1-2.18,2.3l-1.86,1.07v4a.92.92,0,0,1-.09.39.62.62,0,0,1-.22.27l-.94.54a.17.17,0,0,1-.22,0,.4.4,0,0,1-.1-.29V178.79a.94.94,0,0,1,.1-.39.56.56,0,0,1,.22-.27Zm-1.86,6.88,1.8-1a2.82,2.82,0,0,0,1.45-2.64c0-.67-.13-1.05-.4-1.16a1.25,1.25,0,0,0-1,.23l-1.8,1Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.19,172c1-.56,1.7-.64,2.21-.24a3,3,0,0,1,.75,2.44,7.53,7.53,0,0,1-.39,2.45,6.08,6.08,0,0,1-1.14,2l1.6,3.49a.55.55,0,0,1,0,.17.78.78,0,0,1-.07.33.48.48,0,0,1-.18.21l-1,.57c-.15.09-.27.1-.34,0a.65.65,0,0,1-.16-.22L171,180l-1.55.89V185a.92.92,0,0,1-.09.39.56.56,0,0,1-.22.27l-.94.54a.17.17,0,0,1-.22,0,.4.4,0,0,1-.09-.29V174.38a1,1,0,0,1,.09-.4.53.53,0,0,1,.22-.26Zm-1.74,6.63,1.68-1a3,3,0,0,0,1.06-1,2.83,2.83,0,0,0,.39-1.59q0-1-.39-1.11a1.52,1.52,0,0,0-1.06.27l-1.68,1Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,181.73a.17.17,0,0,1-.22,0,.38.38,0,0,1-.09-.28V169.89a.92.92,0,0,1,.09-.39.56.56,0,0,1,.22-.27l.94-.54a.17.17,0,0,1,.22,0,.4.4,0,0,1,.09.29v11.53a.92.92,0,0,1-.09.39.52.52,0,0,1-.22.27Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,174.72l1.94-9.64a2.28,2.28,0,0,1,.13-.36.52.52,0,0,1,.26-.3l.88-.51a.17.17,0,0,1,.22,0,.4.4,0,0,1,.09.29v.06s0,.06,0,.13l-2.6,12.73a3.12,3.12,0,0,1-.16.55.65.65,0,0,1-.28.31l-.93.54c-.12.07-.21.07-.28,0a1,1,0,0,1-.16-.37l-2.6-9.73a.84.84,0,0,1,0-.1v-.06a.92.92,0,0,1,.09-.39.69.69,0,0,1,.22-.27l.89-.51c.11-.07.2-.07.26,0a.94.94,0,0,1,.12.22Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,161.16c.13-.08.22-.08.28,0a.85.85,0,0,1,.17.36l2.84,9.64s0,.07,0,.12a.92.92,0,0,1-.09.39.63.63,0,0,1-.23.27l-.83.48c-.16.09-.26.11-.33,0a.53.53,0,0,1-.12-.22l-.5-1.7-3.67,2.12-.49,2.27a2.78,2.78,0,0,1-.13.37.72.72,0,0,1-.33.34l-.83.48a.17.17,0,0,1-.22,0,.38.38,0,0,1-.09-.28.53.53,0,0,1,0-.13l2.84-12.93a3.12,3.12,0,0,1,.16-.55.65.65,0,0,1,.28-.31Zm.64,7.46-1.27-4.35L188,170.1Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.13,164.39a.94.94,0,0,1,.12-.42.86.86,0,0,1,.21-.24l.94-.54a.18.18,0,0,1,.23,0c.07.05.09.15.09.29a9.81,9.81,0,0,1-.24,1.61,7.87,7.87,0,0,1-.62,1.67,7.67,7.67,0,0,1-1.06,1.58,6,6,0,0,1-1.54,1.26,2.74,2.74,0,0,1-1.41.45,1.49,1.49,0,0,1-1-.41,2.61,2.61,0,0,1-.66-1.18,7.15,7.15,0,0,1-.29-1.82c0-.44,0-.93,0-1.48s0-1,0-1.52a11.73,11.73,0,0,1,.29-2.14,9.13,9.13,0,0,1,.66-1.95,7.51,7.51,0,0,1,1-1.62,5.47,5.47,0,0,1,1.41-1.18,3.21,3.21,0,0,1,1.54-.52,1.67,1.67,0,0,1,1.06.36,2,2,0,0,1,.62,1,5.7,5.7,0,0,1,.24,1.32.81.81,0,0,1-.09.4.66.66,0,0,1-.23.26l-.94.54a.2.2,0,0,1-.22,0q-.11,0-.12-.27a1.76,1.76,0,0,0-.17-.6.93.93,0,0,0-.34-.41,1,1,0,0,0-.56-.12,2,2,0,0,0-.79.29,3,3,0,0,0-.79.67,4.13,4.13,0,0,0-.56.9,4.8,4.8,0,0,0-.35,1.05,6.34,6.34,0,0,0-.14,1.14c0,.46,0,1,0,1.51s0,1.05,0,1.49a4,4,0,0,0,.14,1,1.55,1.55,0,0,0,.35.65.82.82,0,0,0,.56.24,1.34,1.34,0,0,0,.79-.24,3.44,3.44,0,0,0,.79-.62,4.43,4.43,0,0,0,.56-.77,4.17,4.17,0,0,0,.36-.81A4.81,4.81,0,0,0,199.13,164.39Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,150.74a.17.17,0,0,1,.22,0,.4.4,0,0,1,.09.29.88.88,0,0,1,0,.17l-2.75,9v3.93a.92.92,0,0,1-.09.39.52.52,0,0,1-.22.27l-.93.54a.17.17,0,0,1-.22,0,.36.36,0,0,1-.09-.28v-3.93l-2.75-5.86a.29.29,0,0,1,0-.14,1,1,0,0,1,.1-.4.56.56,0,0,1,.22-.27l.87-.5c.15-.09.27-.1.35,0a.46.46,0,0,1,.13.19l1.88,4,1.88-6.13a2,2,0,0,1,.14-.35.81.81,0,0,1,.35-.38Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.23,146.56c.94-.54,1.67-.62,2.18-.24s.78,1.22.78,2.53a7.31,7.31,0,0,1-.78,3.45,5.48,5.48,0,0,1-2.18,2.29l-1.85,1.07v4a.92.92,0,0,1-.09.39.69.69,0,0,1-.22.27l-.94.54a.17.17,0,0,1-.22,0,.37.37,0,0,1-.1-.29V149a.88.88,0,0,1,.1-.4.56.56,0,0,1,.22-.27Zm-1.85,6.87,1.8-1a2.85,2.85,0,0,0,1.45-2.64c0-.67-.14-1.06-.4-1.16a1.28,1.28,0,0,0-1,.22l-1.8,1Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18,148.94a10.63,10.63,0,0,1,.25-2,8.31,8.31,0,0,1,.63-1.9,7.13,7.13,0,0,1,1-1.64,5.42,5.42,0,0,1,1.49-1.24,2.87,2.87,0,0,1,1.47-.48,1.45,1.45,0,0,1,1,.43,2.73,2.73,0,0,1,.64,1.17A7.26,7.26,0,0,1,226,145c0,.22,0,.47,0,.74s0,.55,0,.84,0,.58,0,.85,0,.53,0,.76a12.65,12.65,0,0,1-.25,2,9.23,9.23,0,0,1-.64,1.9,6.49,6.49,0,0,1-1.05,1.63,5.42,5.42,0,0,1-1.47,1.23,3,3,0,0,1-1.49.48,1.48,1.48,0,0,1-1-.42,2.51,2.51,0,0,1-.63-1.17,6.94,6.94,0,0,1-.25-1.74c0-.22,0-.47,0-.74s0-.55,0-.84,0-.58,0-.86S219.17,149.17,219.18,148.94Zm5.25-2.94a2.28,2.28,0,0,0-.54-1.68c-.33-.28-.76-.26-1.3.05a3.35,3.35,0,0,0-1.31,1.46,5.49,5.49,0,0,0-.54,2.3c0,.46,0,1,0,1.52s0,1,0,1.5a2.27,2.27,0,0,0,.54,1.67,1.1,1.1,0,0,0,1.31-.06,3.36,3.36,0,0,0,1.3-1.45,5.44,5.44,0,0,0,.54-2.29c0-.46,0-1,0-1.52S224.45,146.44,224.43,146Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.92,146.62a.17.17,0,0,1,.22,0,.4.4,0,0,1,.09.29v1.26a.93.93,0,0,1-.09.4.62.62,0,0,1-.22.27l-5.08,2.93a.17.17,0,0,1-.22,0,.38.38,0,0,1-.09-.28V140a.93.93,0,0,1,.09-.4.56.56,0,0,1,.22-.27l.94-.54a.17.17,0,0,1,.22,0,.38.38,0,0,1,.09.28v9.79Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.66,147.84a.17.17,0,0,1-.22,0,.4.4,0,0,1-.1-.29V136a.94.94,0,0,1,.1-.39.51.51,0,0,1,.22-.27l.94-.55a.17.17,0,0,1,.22,0,.38.38,0,0,1,.09.28v11.54a.92.92,0,0,1-.09.39.62.62,0,0,1-.22.27Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.71,139.23a.94.94,0,0,1,.12-.42.72.72,0,0,1,.21-.24L244,138a.18.18,0,0,1,.23,0,.34.34,0,0,1,.08.29,8.79,8.79,0,0,1-.23,1.61,7.87,7.87,0,0,1-.62,1.67,7.67,7.67,0,0,1-1.06,1.58,6,6,0,0,1-1.54,1.26,2.77,2.77,0,0,1-1.42.45,1.47,1.47,0,0,1-1-.41,2.62,2.62,0,0,1-.67-1.18,7.65,7.65,0,0,1-.28-1.82c0-.44,0-.93,0-1.48s0-1,0-1.52a12.66,12.66,0,0,1,.28-2.14,9.14,9.14,0,0,1,.67-1.95,7.48,7.48,0,0,1,1-1.62,5.52,5.52,0,0,1,1.42-1.18,3.21,3.21,0,0,1,1.54-.52,1.67,1.67,0,0,1,1.06.36,2,2,0,0,1,.62,1,5.21,5.21,0,0,1,.23,1.32.8.8,0,0,1-.08.4.66.66,0,0,1-.23.26l-.94.54a.2.2,0,0,1-.22,0c-.07,0-.11-.12-.13-.27a1.56,1.56,0,0,0-.16-.6.89.89,0,0,0-.35-.41.94.94,0,0,0-.55-.12,2,2,0,0,0-.79.29,2.82,2.82,0,0,0-.79.67,4.13,4.13,0,0,0-.56.9,4.8,4.8,0,0,0-.35,1,6.34,6.34,0,0,0-.14,1.14c0,.46,0,1,0,1.51s0,1.05,0,1.49a4,4,0,0,0,.14,1,1.55,1.55,0,0,0,.35.65.82.82,0,0,0,.56.24,1.36,1.36,0,0,0,.79-.24,3.44,3.44,0,0,0,.79-.62,4.43,4.43,0,0,0,.56-.77,3.61,3.61,0,0,0,.35-.81A4,4,0,0,0,242.71,139.23Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.58,125.58a.17.17,0,0,1,.22,0,.4.4,0,0,1,.09.29.88.88,0,0,1,0,.17l-2.75,9V139a.92.92,0,0,1-.09.39.67.67,0,0,1-.22.28l-.93.53a.17.17,0,0,1-.22,0,.36.36,0,0,1-.09-.28V136l-2.75-5.86a.29.29,0,0,1,0-.14.85.85,0,0,1,.1-.4.56.56,0,0,1,.22-.27l.87-.5c.15-.09.27-.1.34,0a.41.41,0,0,1,.14.19l1.88,4,1.88-6.13a2,2,0,0,1,.14-.35.86.86,0,0,1,.35-.38Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,152.16,154.42,211.27c-.85.49-1.55,0-1.55-1.18v-.31a3.72,3.72,0,0,1,1.55-3l102.39-59.11c.86-.5,1.55,0,1.55,1.17v.31A3.73,3.73,0,0,1,256.81,152.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,184.54,154.42,243.65c-.85.5-1.55,0-1.55-1.17v-.31a3.74,3.74,0,0,1,1.55-3l102.39-59.11c.86-.5,1.55,0,1.55,1.17v.31A3.71,3.71,0,0,1,256.81,184.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,198.69,154.42,257.8c-.85.5-1.55,0-1.55-1.17v-.31a3.74,3.74,0,0,1,1.55-3l102.39-59.11c.86-.5,1.55,0,1.55,1.17v.31A3.73,3.73,0,0,1,256.81,198.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,328,154.42,387.13c-.85.5-1.55,0-1.55-1.17v-.31a3.76,3.76,0,0,1,1.55-3l102.39-59.11c.86-.49,1.55,0,1.55,1.18v.31A3.69,3.69,0,0,1,256.81,328Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,342.17,154.42,401.28c-.85.5-1.55,0-1.55-1.17v-.31a3.76,3.76,0,0,1,1.55-3l102.39-59.11c.86-.49,1.55,0,1.55,1.18v.31A3.69,3.69,0,0,1,256.81,342.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,212.84,154.42,272c-.85.49-1.55,0-1.55-1.17v-.31a3.73,3.73,0,0,1,1.55-3l102.39-59.11c.86-.5,1.55,0,1.55,1.17v.31A3.73,3.73,0,0,1,256.81,212.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.81,170.55l-82.39,47.58c-.86.49-1.56,0-1.56-1.18v-.31a3.7,3.7,0,0,1,1.56-3l82.39-47.58c.86-.49,1.56,0,1.56,1.18v.31A3.7,3.7,0,0,1,246.81,170.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,245.92,154.42,305c-.85.5-1.55,0-1.55-1.17v-.31a3.74,3.74,0,0,1,1.55-3l102.39-59.11c.86-.5,1.55,0,1.55,1.17V243A3.71,3.71,0,0,1,256.81,245.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,260.38,154.42,319.49c-.85.49-1.55,0-1.55-1.17V318a3.74,3.74,0,0,1,1.55-3l102.39-59.11c.86-.5,1.55,0,1.55,1.17v.31A3.71,3.71,0,0,1,256.81,260.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,231.57l-95.64,55.22c-.85.49-1.55,0-1.55-1.18v-.31a3.72,3.72,0,0,1,1.55-3l95.64-55.22c.86-.49,1.55,0,1.55,1.18v.3A3.7,3.7,0,0,1,256.81,231.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.31,290.73h0c-.79.46-1.44,0-1.44-1.09v-.59a3.46,3.46,0,0,1,1.44-2.75h0c.79-.46,1.44,0,1.44,1.09V288A3.46,3.46,0,0,1,154.31,290.73Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,293.79,154.42,352.9c-.85.49-1.55,0-1.55-1.18v-.3a3.73,3.73,0,0,1,1.55-3l102.39-59.11c.86-.5,1.55,0,1.55,1.17v.31A3.73,3.73,0,0,1,256.81,293.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,308.25,154.42,367.36c-.85.49-1.55,0-1.55-1.18v-.31a3.72,3.72,0,0,1,1.55-3L256.81,303.8c.86-.5,1.55,0,1.55,1.17v.31A3.73,3.73,0,0,1,256.81,308.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,279.44l-95.64,55.21c-.85.5-1.55,0-1.55-1.17v-.31a3.76,3.76,0,0,1,1.55-3L256.81,275c.86-.5,1.55,0,1.55,1.17v.31A3.71,3.71,0,0,1,256.81,279.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.31,338.59h0c-.79.46-1.44,0-1.44-1.08v-.6a3.46,3.46,0,0,1,1.44-2.74h0c.79-.46,1.44,0,1.44,1.08v.6A3.43,3.43,0,0,1,154.31,338.59Z",
    style: {
      fill: "#D6D6D6"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shield--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.44,58.29A25.7,25.7,0,0,1,93.06,56c.37-.91.68-1.77,1-2.59a25.61,25.61,0,0,0,8.47,8.36Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.44,58.29A25.7,25.7,0,0,1,93.06,56c.37-.91.68-1.77,1-2.59a25.61,25.61,0,0,0,8.47,8.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.68,66.8c.16,36.19.46,85-40.62,124.42l-.89.85-1.22.24a38.87,38.87,0,0,1-7.5.76A27.4,27.4,0,0,1,71,187.2a28.87,28.87,0,0,0,10.67,1.94,39.1,39.1,0,0,0,7.5-.76l1.2-.23.89-.86c41.09-39.42,40.8-88.23,40.62-124.42,0-1.94,0-3.8,0-5.58l0,0,6.77-5.34v8.63C138.65,62.53,138.66,64.62,138.68,66.8Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.68,66.8c.16,36.19.46,85-40.62,124.42l-.89.85-1.22.24a38.87,38.87,0,0,1-7.5.76A27.4,27.4,0,0,1,71,187.2a28.87,28.87,0,0,0,10.67,1.94,39.1,39.1,0,0,0,7.5-.76l1.2-.23.89-.86c41.09-39.42,40.8-88.23,40.62-124.42,0-1.94,0-3.8,0-5.58l0,0,6.77-5.34v8.63C138.65,62.53,138.66,64.62,138.68,66.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.17,192.07h0l.89-.85C139.14,151.8,138.84,103,138.68,66.8c0-2.18,0-4.27,0-6.24V51.93l-3.55,2.8-3.22,2.54h0l0,.08c0,1.76,0,3.6,0,5.52.18,36.19.47,85-40.62,124.42l-.89.86,6.8,3.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.33,60.79c-2.41,0-5.74-1-9.6-4.33a10.31,10.31,0,0,0,2.8.4c5.45,0,11.31-2.35,17-6.8L136,39.37l6.8,3.93L129.28,54C123.63,58.43,117.78,60.79,112.33,60.79Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.33,60.79c-2.41,0-5.74-1-9.6-4.33a10.31,10.31,0,0,0,2.8.4c5.45,0,11.31-2.35,17-6.8L136,39.37l6.8,3.93L129.28,54C123.63,58.43,117.78,60.79,112.33,60.79Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.47,60.56l-6.8-3.93c-11.42,9-22.48,10-30.41,7.22a16.84,16.84,0,0,1-2.11-2.21l-6.79-3.93C82,73.2,65.89,95.85,49,102c0,27.87-2,66.84,20.48,79.83l6.81,3.93c5,2.88,11.16,3.91,18.82,2.41h0C137.4,147.65,134.47,94.61,134.47,60.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.48,106.45l5.67-44.81h0l-6.79-3.93C82,73.2,65.89,95.85,49,102l6.8,3.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.46,187.21a21.44,21.44,0,0,1-16-6.49c-15.31-15.39-15.13-42.65-15-68.48,0-1.78,0-3.5,0-5.14,17.08-6.93,31.83-28.58,38.15-42.43a24.26,24.26,0,0,0,16.67,6.16h0c6.8,0,13.82-2.4,20.47-7,0,1,0,2,0,3C133,102,133.26,149,94.35,186.65a33.34,33.34,0,0,1-5.89.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.14,66.92c.17,34.78.41,81-37.59,118.17a30.6,30.6,0,0,1-5.09.45,19.84,19.84,0,0,1-14.77-6c-14.82-14.89-14.64-41.74-14.52-67.31,0-1.38,0-2.72,0-4,16.27-7.2,30.3-27,37.05-40.86a26.55,26.55,0,0,0,16.09,5.16,36.81,36.81,0,0,0,18.81-5.59m3.33-6.36c-7.85,6.18-15.53,8.6-22.14,8.6-7.59,0-13.76-3.18-17.18-7.52C88.77,77.13,72.69,99.78,55.84,106c0,32.14-2.61,82.94,32.62,82.94a34.4,34.4,0,0,0,6.69-.69h0c42.25-40.55,39.32-93.59,39.32-127.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.26,163.28l43.62-25.18-.72-6.28c-.45-4-2-6.76-4.32-8.07l-6.06-3.5c-2.27-1.31-5.22-1.17-8.41.68l-16.73,9.65c-6.41,3.7-11.84,13.12-12.74,22.09l-.71,7.11Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.26,163.28l43.62-25.18-.72-6.28c-.45-4-2-6.76-4.32-8.07l-6.06-3.5c-2.27-1.31-5.22-1.17-8.41.68l-16.73,9.65c-6.41,3.7-11.84,13.12-12.74,22.09l-.71,7.11Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.16,131.82c-.45-4-2-6.76-4.32-8.07s-5.22-1.17-8.41.68L88.7,134.09C82.3,137.78,76.87,147.2,76,156.18l-.71,7.1,43.62-25.18Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51,97c2.15,1.24,3.47,3.9,3.47,7.69,0,7.57-5.31,16.77-11.87,20.56-3.27,1.89-6.24,2.07-8.39.83l-6-3.44c-2.14-1.24-3.47-3.9-3.47-7.69,0-7.57,5.31-16.77,11.87-20.55,3.27-1.9,6.24-2.08,8.39-.84Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51,97c2.15,1.24,3.47,3.9,3.47,7.69,0,7.57-5.31,16.77-11.87,20.56-3.27,1.89-6.24,2.07-8.39.83l-6-3.44c-2.14-1.24-3.47-3.9-3.47-7.69,0-7.57,5.31-16.77,11.87-20.55,3.27-1.9,6.24-2.08,8.39-.84Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.11,125.27c-3.27,1.89-6.24,2.07-8.39.83s-3.47-3.9-3.47-7.69c0-7.57,5.31-16.77,11.87-20.55,3.27-1.9,6.24-2.08,8.39-.84s3.47,3.9,3.47,7.69C110,112.28,104.67,121.48,98.11,125.27Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.08,39.56C82,58.36,60.82,88.79,46.16,94.17l-5.49,2,6.8,3.93,5.49-2c14.66-5.37,35.8-35.81,39.92-54.61Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.08,39.56C82,58.36,60.82,88.79,46.16,94.17l-5.49,2,6.8,3.93,5.49-2c14.66-5.37,35.8-35.81,39.92-54.61Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.38,187.81c-18.26-18.35-18.06-48.12-17.93-75.61q0-3.28,0-6.25v-5.84l-6.8-3.93V102c0,2,0,4.06,0,6.24-.13,27.5-.32,57.26,17.93,75.61a32.59,32.59,0,0,0,6.74,5.23l6.3,3.64A32.58,32.58,0,0,1,65.38,187.81Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.38,187.81c-18.26-18.35-18.06-48.12-17.93-75.61q0-3.28,0-6.25v-5.84l-6.8-3.93V102c0,2,0,4.06,0,6.24-.13,27.5-.32,57.26,17.93,75.61a32.59,32.59,0,0,0,6.74,5.23l6.3,3.64A32.58,32.58,0,0,1,65.38,187.81Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.86,66.77q0-3.26,0-6.21V43.3L129.29,54c-5.65,4.46-11.52,6.81-17,6.81-4.3,0-11.51-3.08-19.45-17.31C88.75,62.29,67.62,92.72,53,98.09l-5.49,2V106c0,2,0,4.06,0,6.24-.13,27.5-.33,57.27,17.93,75.62a31.45,31.45,0,0,0,23.08,9.45,44.17,44.17,0,0,0,8.3-.84l2.41-.47,1.78-1.71C143.33,153.57,143,103.64,142.86,66.77ZM98.05,191.22l-.89.85-1.2.24a39,39,0,0,1-7.5.76,27.34,27.34,0,0,1-20.11-8.22c-17-17.11-16.84-45.83-16.71-72.64q0-3.28,0-6.26V103l2.74-1c15.91-5.83,35-34.49,39.62-48.6C98.35,60.56,106.55,65,112.33,65h0c6.39,0,13.15-2.67,19.55-7.71l6.77-5.34v8.63q0,3,0,6.23C138.85,103,139.14,151.79,98.05,191.22Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.86,66.77q0-3.26,0-6.21V43.3L129.29,54c-5.65,4.46-11.52,6.81-17,6.81-4.3,0-11.51-3.08-19.45-17.31C88.75,62.29,67.62,92.72,53,98.09l-5.49,2V106c0,2,0,4.06,0,6.24-.13,27.5-.33,57.27,17.93,75.62a31.45,31.45,0,0,0,23.08,9.45,44.17,44.17,0,0,0,8.3-.84l2.41-.47,1.78-1.71C143.33,153.57,143,103.64,142.86,66.77ZM98.05,191.22l-.89.85-1.2.24a39,39,0,0,1-7.5.76,27.34,27.34,0,0,1-20.11-8.22c-17-17.11-16.84-45.83-16.71-72.64q0-3.28,0-6.26V103l2.74-1c15.91-5.83,35-34.49,39.62-48.6C98.35,60.56,106.55,65,112.33,65h0c6.39,0,13.15-2.67,19.55-7.71l6.77-5.34v8.63q0,3,0,6.23C138.85,103,139.14,151.79,98.05,191.22Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.37,392.13c-1.07-14.33.58-25.32-.64-47.7h0c-.11-5.74-.32-11.88-.72-17.34-1.32-18.37-4.22-24.65-4.49-28.2,0,0-.5-28.58-1.73-68.78-.58-18.9-6.19-24.63-10.67-34.67H367.67c-5.95,24.77-5.5,78.78-5.32,104.3.09,13,5.47,82.63,5.58,84.23.38,5.68-.13,7.92-2.41,10.31-4.77,5-11.69,9.76-17.68,14.13.87,2.23,8.07,2.15,11.63.45a91.56,91.56,0,0,0,13.28-8.27c4.92-3.55,11.2-6.4,11.28-11.81a6,6,0,0,1,.16-1c.1-3.16,7.64-49.72,8.26-60.53.54-9.29-.62-25.06-.62-25.06L398,262.87s3.79,23.26,7.62,39.14c3.11,12.93,8.25,35,11.76,50.9h0c3.37,18.33,8.32,31.38,9.18,40.56.25,2.19,2.79,23.69,3.84,28.62s12.05,5.05,12.75-3.42C443.59,413,441.57,394.83,441.37,392.13Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.66,414.12c-.3,0-.8,3.27.84,4.68,1.89,1.62,7.46,4.32,14.87,3.46s11.44-3.05,14.43-5.44,7.17-5.75,10.53-6.44c3.11-.64,6.5-2,7.51-2.91s.91-5.1.91-5.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.35,386.28s.56,0,.74,1c.21,1.16.42,4.5.89,6.39.65,2.63,1,8,.62,10.15s-5.52,3.56-8.77,4.73a41.88,41.88,0,0,0-10.57,6.36c-3.5,2.77-10.85,5.5-15.67,5.52-7.36,0-12.11-2-13.55-4.57-1.79-3.22-.34-5.05,8.16-8.79,1.61-.71,7.27-3.9,9.2-5.06a43.21,43.21,0,0,0,5.8-4.13,30.36,30.36,0,0,0,2.61-2.46,11.66,11.66,0,0,0,2.18-2.65c.09-.22.16-.48.25-.7a11,11,0,0,0,.57-1.93c.15-.69.24-1.69.92-2.09a5.75,5.75,0,0,1,3-.32,22.16,22.16,0,0,1,3.25.49c1.25.28,2.69.41,3.41,1.55a6,6,0,0,1,.67,3c0,.49,0,1,0,1.46,0,.2-.09.57.21.49s.6-.8.71-1c.24-.54.4-1.12.66-1.64a7.93,7.93,0,0,1,2.43-3.06,14.11,14.11,0,0,0,1.45-.9A3.33,3.33,0,0,0,384.35,386.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.83,407.67c10.65.83,13.94,7.29,14.34,11.28a25.92,25.92,0,0,1-7.58,1.47c-7.36,0-12.41-2-13.86-4.57C336.05,412.81,337.24,410.39,344.83,407.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.81,408a.54.54,0,0,0,.33-.12.5.5,0,0,0,.08-.71,12.7,12.7,0,0,0-9.6-3.81.51.51,0,0,0-.47.55.52.52,0,0,0,.57.46,11.8,11.8,0,0,1,8.69,3.43A.52.52,0,0,0,360.81,408Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.42,405.38a.53.53,0,0,0,.34-.11.5.5,0,0,0,.08-.71,12.7,12.7,0,0,0-9.6-3.82.51.51,0,1,0,.1,1,11.72,11.72,0,0,1,8.68,3.43A.5.5,0,0,0,365.42,405.38Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.71,402.44a.46.46,0,0,0,.33-.11.49.49,0,0,0,.08-.71,12.65,12.65,0,0,0-9.59-3.81.5.5,0,0,0-.47.55.52.52,0,0,0,.57.46,11.74,11.74,0,0,1,8.68,3.43A.5.5,0,0,0,369.71,402.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.91,399.5a.47.47,0,0,0,.32-.1.51.51,0,0,0,.1-.72c-2-2.53-6.61-4.24-10.49-3.87a.51.51,0,0,0-.46.56.5.5,0,0,0,.56.45c3.49-.33,7.78,1.24,9.56,3.49A.53.53,0,0,0,373.91,399.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.92,425.93c.29,4.91,1.07,8.16,2.86,11s5.15,3.78,8.55,2.94,7.78-3.1,8.75-7.33,1.55-7.14.78-11.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.25,390.38c1.4.11,1.82,6.7,2.63,13.3.86,7.07,3,10,3.8,15.8.89,6.62-.24,9.58-2.61,13.59s-10.8,7.94-14.95,2.2c-3.38-4.68-3.52-9.87-3.21-16.48a145,145,0,0,0-.45-16.77c-.28-5-1.4-10-.18-10.52.09.73.18,1.66.28,2.37a11.86,11.86,0,0,0,.46,2.65c.14.37.45.75.58.15a3.63,3.63,0,0,0,0-1.23c-.21-1.83.74-2,1.25-2.12a62.39,62.39,0,0,1,6.51-.9c1.07-.07,4.78-.23,5.26.37a4.06,4.06,0,0,1,.47,1.91c.12,1,.36,1.73.39,1.42.06-.72-.08-2.57-.1-3s-.09-1-.09-1.45S441.28,390.8,441.25,390.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.07,423.32a16.21,16.21,0,0,1-2.63,10.07c-2.37,4-11.47,7.95-15.62,2.21-2.06-2.86-2.61-6.23-2.9-9.68C429.41,421.5,444.15,419.55,448.07,423.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,418.72a.64.64,0,0,0,.17-.05c.06,0,6.55-2.65,12.88-1.22a.52.52,0,0,0,.62-.38.5.5,0,0,0-.39-.61c-6.69-1.51-13.31,1.18-13.56,1.29a.51.51,0,0,0-.25.68A.53.53,0,0,0,430,418.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.72,412.51a.54.54,0,0,0,.45-.34.52.52,0,0,0-.33-.65c-6.3-2.08-13.28,1.05-13.55,1.18a.51.51,0,0,0-.22.69.54.54,0,0,0,.71.21c.06,0,6.87-3.06,12.72-1.11A.57.57,0,0,0,442.72,412.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.5,407.85a.51.51,0,0,0,.44-.33.5.5,0,0,0-.31-.65c-6.93-2.42-13.56,1-13.81,1.14a.51.51,0,0,0-.17.7.52.52,0,0,0,.71.17c.06,0,6.47-3.3,12.91-1.05A.62.62,0,0,0,442.5,407.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.16,403.27a.51.51,0,0,0,.43-.33.5.5,0,0,0-.3-.65c-6.49-2.37-13.63,1.13-13.9,1.28a.5.5,0,0,0-.19.69.51.51,0,0,0,.71.19c.07,0,7-3.41,13-1.21A.5.5,0,0,0,442.16,403.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.72,195.61c.86,15.94,2.82,20.43,3.46,53.86s.54,42.79.67,46.82,2.54,11.24,4.65,31.1-.39,43.51-.39,43.51-1.45,3.2-9.23,3.88c-7.17.62-10.72-2-10.72-2s-9.84-38.67-12.56-50.63S398,270.87,398,270.87l-4.69,31.89s2.19,11,0,28.37-6,35.25-6,35.25a33,33,0,0,1-11,1.76,18.92,18.92,0,0,1-9.67-2.47s-6.1-51.81-6.1-71.55,1.58-70,2.8-98.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.06,311.72q-.39-1.71-.72-3.27c-2-9.23-1.95-21.31-1.92-36.6,0-4.62,0-9.4,0-14.48-.18-19.91-1.75-42.2-12.06-56.58l-.83.57c6.93,9.66,9.85,23,11.06,36.84-10.24-1.32-12.48-11.2-15.53-24.79-.42-1.86-.85-3.78-1.32-5.75l-1,.22c.47,2,.9,3.89,1.32,5.74,3,13.57,5.46,24.31,16.6,25.61.5,6.08.68,12.22.73,18.15.05,5.07,0,9.85,0,14.47,0,15.35-.06,27.47,2,36.81q.33,1.56.72,3.27c2.65,11.95,6.62,29.87,4.64,61.07a8.56,8.56,0,0,0,1.06-.67C441.65,341.44,437.7,323.63,435.06,311.72Zm-63.94-81.85c1.42,6.57,12.16,12.1,17,13.24l1.24,6.68c-.24,3.55-.5,7.28-.77,11.14-1.49,21.23-3.6,37.61-2.48,42.57,2.93,13,2.06,21.3.49,36.31-.16,1.54-.33,3.14-.5,4.83-.89,8.71-1.88,17.26-2.53,22.74l1.06-.24c.64-5.49,1.61-13.87,2.48-22.4.17-1.69.34-3.29.5-4.83,1.58-15.11,2.45-23.43-.51-36.63-1.08-4.81,1.09-22.11,2.5-42.29.17-2.44.34-4.84.5-7.18l3.77,18-.62,31L398,270.87l-5.83-32.39S378.63,237.54,371.12,229.87Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.3,125.73c-6.33,1-12.53,3.93-17.32,13.47-3.94,7.84-6.9,17.24-11.73,30.42l-26-.42,4.62,16.59s15.51,2.41,23.49,3.39c10.21,1.25,11.33.61,14.05-4.83,4.75-9.53,10.06-25.93,10.06-25.93Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.3,125.42c-5,.93-10.84,1.71-15.17,8.9S346,166.25,346,166.25s2.49,3.11,9,6.57,11.19,2.41,11.19,2.41l6.33-16.61Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-5",
    d: "M409.06,123.86c10.5,2.36,15.92,3.9,20.89,5.06,0,0,5.7,6.71,5.15,42.3-.06,4.32-1.1,35.1-.32,45.55,0,0-17.53,9.93-46.91,6.92C364.81,221.33,362,212.74,362,212.74s1.3-31.49,1.61-48.54c.41-22.15,2.61-32,10.65-38.78l16.47-2.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-5",
    d: "M390.81,123.42l18.13,1.27c6.62,1.48,11.23,2.65,14.95,3.59,2.05.52,3.83,1,5.56,1.37.85,1.38,5.31,10.15,4.82,41.55,0,.76,0,2.32-.11,4.43-.25,9.54-.83,31.61-.25,40.66-2.5,1.27-15.17,7.14-35.07,7.14a105.49,105.49,0,0,1-10.88-.57c-20.65-2.11-24.64-9.29-25.09-10.26.11-2.59,1.32-32.18,1.61-48.39.42-22.75,2.8-31.7,10.18-38l16.15-2.78m0-.84-16.47,2.84c-8,6.76-10.24,16.63-10.65,38.78-.31,17.05-1.61,48.54-1.61,48.54s2.77,8.59,25.83,10.95a106.62,106.62,0,0,0,11,.57c22.72,0,35.94-7.49,35.94-7.49-.78-10.45.26-41.23.32-45.55.55-35.59-5.15-42.3-5.15-42.3-5-1.16-10.39-2.7-20.89-5.06l-18.29-1.28Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.94,85.19c-1.66,6,3,11.72,5.22,13.45-.21,3.47-.34,11.1-.36,14.63,6.21-1.41,16.43-33.35,5.77-36.88,1.27-6.63-6.49-10.08-12.65-11.8s-8.81-4.87-14.2-3.42a4.59,4.59,0,0,0-3.14,4,11.74,11.74,0,0,0-7.25-.22c-3,.64-4.75,5.17-1.5,6.59-2.67.37-6,2.23-5.5,5.32a3.21,3.21,0,0,0,3.12,2.53c-3.09.52-5.55,3.68-2.7,6.16a2,2,0,0,1,.47,1.76c-.21.6-1,1-1.49.39a2.31,2.31,0,0,0,3.87-.6c.35-.75.06-1.54.29-2.34.92,3.39,5.23,2,7.78,2.32C392,86,399.54,86,406.94,85.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.82,107.07c-4.44,2.23-6.52-1.28-6.52-1.28l.24,20.29c-8.43,11.57-32,6.32-22.77-2.39l0-5.45a32.31,32.31,0,0,1-3.87-.37c-4-.57-6.48-4.32-7.71-8.59-1.82-6.31-1.08-19.19-.15-24.93,1-6,2.58-8.8,3.52-9.46,4.92.88,7.66,4.79,15.24,5.54,4.69.47,8.39-.18,10.13-1-1.1,7.83.15,11.4.79,13.48.92,3,2.21,4.45,2.84,4.58,2.71.53,3-1.8,4.19-3.08a5,5,0,0,1,7.77,1.68A8.11,8.11,0,0,1,419.82,107.07Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.47,110.89c-1.22,5.86-9.67,9.36-19.71,9.73l0-2.38a46.47,46.47,0,0,0,7.35-.76C403.91,116.45,408.49,114.15,410.47,110.89Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.54,91.85a1.94,1.94,0,1,1-1.89-2A1.93,1.93,0,0,1,400.54,91.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06,91.57a1.94,1.94,0,1,1-1.89-2A1.76,1.76,0,0,1,386.06,91.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.63,90.42l-1.83,11.52-6-1.42A22.93,22.93,0,0,1,392.63,90.42Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.44,87.55l4.62-1.39a2.31,2.31,0,0,0-2.92-1.66A2.55,2.55,0,0,0,381.44,87.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.83,87.47l-4.27-2.37a2.34,2.34,0,0,1,3.25-1A2.55,2.55,0,0,1,401.83,87.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.46,103.37,389.77,106a3.53,3.53,0,0,0,4.59,2.17A3.75,3.75,0,0,0,396.46,103.37Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,104.63a3.71,3.71,0,0,1,.86-.12,3.69,3.69,0,0,1-2.3,3.62,3.28,3.28,0,0,1-1.13.22A3.28,3.28,0,0,1,395.8,104.63Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.2,145.87h0l1.69-1.13v0a1.72,1.72,0,0,1,1.6,0l18.76,7.75a6.15,6.15,0,0,1,3.31,3.94l7.73,35.89a1.58,1.58,0,0,1-.44,1.73h0l-1.74,1.16v0a1.73,1.73,0,0,1-1.61,0l-18.77-7.75a6.16,6.16,0,0,1-3.3-3.94l-7.73-35.9C312.49,146.77,312.71,146.15,313.2,145.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.22,154.84a6.07,6.07,0,0,1,1.61,2.77l7.74,35.88a1.65,1.65,0,0,1-.38,1.7l1.64-1.09h0a1.6,1.6,0,0,0,.44-1.73l-7.74-35.9a5.82,5.82,0,0,0-1.48-2.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.56,193.49l-7.73-35.89a6.19,6.19,0,0,0-3.3-3.94l-18.77-7.75c-1.49-.61-2.42.18-2.08,1.74l7.73,35.9a6.16,6.16,0,0,0,3.3,3.94l18.77,7.75C344,195.84,344.9,195.06,344.56,193.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.93,164.82l-1.45-6.72a1.13,1.13,0,0,0-.62-.73l-3-1.23c-.28-.11-.45,0-.39.33.29,1.32,1.16,5.4,1.45,6.72a1.13,1.13,0,0,0,.62.73l3,1.23C335.82,165.26,336,165.11,335.93,164.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.14,159.62a2.9,2.9,0,0,0-1.58-1.82c-.72-.29-1.18,0-1,.76a2.87,2.87,0,0,0,1.58,1.83C333.84,160.68,334.29,160.34,334.14,159.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.83,163a2.88,2.88,0,0,0-1.58-1.82c-.72-.3-1.18,0-1,.76a2.88,2.88,0,0,0,1.58,1.82C334.53,164.07,335,163.72,334.83,163Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.18,168.83c-1.41-2.21-1.25-2.48-.37-3.53a6.71,6.71,0,0,1,5.59-2.5c1.87.15,3.76.22,4.7.76s0,2.54-2.46,3c-3.88.66-3.91,1.7-3.91,1.7a49.92,49.92,0,0,1,5-.61,36.49,36.49,0,0,1,5.58,1.15c1.61.34,1.82,2.44-1,3l2.94.63c2.06.44,2.71,1.58,1,2.78a3.06,3.06,0,0,1-1.92.61s2.21.11,2.22.85c0,2.12-1.38,2.6-5.91,3.66-4.33,1-5.33,3.26-4.56,4.89,0,0-1.67-1.09-3.14-2.23-1.08-.83-2-1.75-1.39-3.47,0,0-2.44-.08-2.5-1.59a7.81,7.81,0,0,1,.75-3.2,2.66,2.66,0,0,1-1.21-2.57,4.3,4.3,0,0,1,1-2.6Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.35,171.78a13.76,13.76,0,0,0-2.68-.43A8.34,8.34,0,0,0,322,172a31.19,31.19,0,0,0-4.83,2.26,30.6,30.6,0,0,0,5.1-1.53,13.85,13.85,0,0,1,2.43-.81C325.53,171.87,326.46,171.9,327.35,171.78Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.38,175.8a6,6,0,0,0-2.91-.24,14.78,14.78,0,0,0-2.82.73,27.58,27.58,0,0,0-5.22,2.45,57.23,57.23,0,0,0,5.48-1.71A15,15,0,0,1,329.38,175.8Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.85,130c8.36,2,11,4.81,13.89,14.2,2.77,9.09,9.22,29.54,6,42.76-2,8.06-20.23-12.81-20.23-12.81l-6.85-29.45S426.5,130.18,431.85,130Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,128.92c4.64.91,11,1.59,14.44,9.62s7.67,26.6,8.22,30.65c-9.2,6.65-21.43,5.54-21.43,5.54l-7.29-30S423.29,134.37,430,128.92Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.73,141.05c-1.64-2.68-3.33-5.43-4-9.32s-3.46-7.6-4.38-9.12-3-3.79-4.54-5.94-2-2.74-4.4-3.32c-3.3-.79-5.88-1.49-7.21-1.19s-1.35,1.17-.3,2.4,3.42,1.68,4.15,2,2.3,1.09,2.3,1.09l2.78,4.76a46.8,46.8,0,0,0-6.37,1.09c-1.06.49-2.12,3.09-1.77,4.58,0,0-2,1.17-1.39,3.11,0,0-1.28,1.45-.56,2.76a20.57,20.57,0,0,0,2.88,3.67c.6.6,3.11.91,3.11.91a23.15,23.15,0,0,0,3.63,4.85c1.71,1.46,2.89,1.45,4.67,4.37Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.72,122.68c-.7-.62-1.79-1.68-3-1.31s-.47,1.92-.47,1.92Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,128.16a11.66,11.66,0,0,1,2.66-1.47c.88-.36,2.71-.87,2.71-.87a12.71,12.71,0,0,0-3.69.62,10.6,10.6,0,0,0-1.77.74,3,3,0,0,0,.06.86Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.71,129.91a10.2,10.2,0,0,0-1.25.53,3.9,3.9,0,0,0,.15.85c.75-.92,3.43-1.82,3.43-1.82A10.7,10.7,0,0,0,404.71,129.91Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.44,139.2a26.49,26.49,0,0,0-2.28-4.29,1.88,1.88,0,0,0-2.54-.41c-.36.47,1.34.52,1.82.78A16.3,16.3,0,0,1,409.44,139.2Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.55,122.33s-.86-1.42-2.43-3.68-1.49-2-3.13-2.4-4.76-1.21-5.55-2.28a4.29,4.29,0,0,0,.44.59c1,1.2,3.42,1.68,4.15,2s2.3,1.09,2.3,1.09l2.86,4.9Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.73,141.05c5.13,7.14,19.1,24.4,22.15,31.1,2.1,4.64,2,15.07-.73,18.67s-9.65,1.54-15-3.86c-4.62-4.65-8-15.33-11.07-23s-6.77-16.28-6.77-16.28Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.78,135.37a18.27,18.27,0,0,1-.89-3.07,17.56,17.56,0,0,0-.81-3.11,29.66,29.66,0,0,0-3-5.66,45.77,45.77,0,0,0-3.81-5.16c-.67-.84-1.29-1.7-1.92-2.57a5.62,5.62,0,0,0-2.43-2.12,25.74,25.74,0,0,0-3.11-.86c-1-.26-2.08-.51-3.14-.7a11,11,0,0,0-1.62-.18,2.81,2.81,0,0,0-1.63.4.92.92,0,0,0-.4.81,1.78,1.78,0,0,0,.28.83,4,4,0,0,0,1.11,1.23,10.21,10.21,0,0,0,3,1.27,16.76,16.76,0,0,1,2.86,1.25l2.64,4.52a52,52,0,0,0-5.52.89,3.38,3.38,0,0,0-.72.24,2,2,0,0,0-.59.5,5.17,5.17,0,0,0-.75,1.28,5.27,5.27,0,0,0-.44,2.83,3.68,3.68,0,0,0-1.22,1.32,2.54,2.54,0,0,0-.26.93,2.68,2.68,0,0,0,.1.89,2.79,2.79,0,0,0-.64,2.59,12.37,12.37,0,0,0,1.55,2.28c.29.36.58.71.89,1.05a3.2,3.2,0,0,0,1.06.9,11.52,11.52,0,0,0,2.64.62c.53.89,1.09,1.75,1.7,2.59a12.58,12.58,0,0,0,2.1,2.33c.81.68,1.77,1.14,2.56,1.81a9.62,9.62,0,0,1,2,2.41,10,10,0,0,0-2-2.44c-.79-.69-1.74-1.17-2.53-1.84a12.45,12.45,0,0,1-2.05-2.35c-.61-.85-1.16-1.73-1.68-2.63l0,0H409a11,11,0,0,1-2.62-.62,3,3,0,0,1-1-.86c-.3-.34-.59-.69-.88-1a12.52,12.52,0,0,1-1.5-2.24,2.57,2.57,0,0,1,.65-2.41l0,0v-.06a2.36,2.36,0,0,1-.1-.87,2,2,0,0,1,.24-.83,3.4,3.4,0,0,1,1.2-1.27l.07-.05V128a4.88,4.88,0,0,1,.42-2.75c.39-.85.91-1.75,1.89-1.86a57.62,57.62,0,0,1,5.72-.88l.23,0-.11-.2-2.77-4.76,0,0,0,0a16.74,16.74,0,0,0-3-1.31,10.34,10.34,0,0,1-2.9-1.21,3.8,3.8,0,0,1-1-1.13c-.27-.43-.38-1,0-1.24a4.55,4.55,0,0,1,3-.17c1,.18,2.08.43,3.12.68a24.51,24.51,0,0,1,3.08.83,5.37,5.37,0,0,1,2.33,2c.63.86,1.26,1.73,1.94,2.56a46.43,46.43,0,0,1,3.82,5.13,29,29,0,0,1,3.05,5.61,16.14,16.14,0,0,1,.85,3.08,19.39,19.39,0,0,0,.93,3.07,35.26,35.26,0,0,0,3,5.65A35.18,35.18,0,0,1,425.78,135.37Z",
    style: {
      fill: "#af6152"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.66,86.32l11.15,6.46-4.43,10a1,1,0,0,1-.42.48l-5.69,3.27a1,1,0,0,1-1.5-.6L449,89.6Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.48,37.1,481,57a2,2,0,0,1,.91,1.57l0,42.77A2,2,0,0,1,481,103l-5.12,2.89a2,2,0,0,1-1.82,0L439.5,85.89a2,2,0,0,1-.9-1.58l0-42.77a2,2,0,0,1,.91-1.56l5.12-2.89A2,2,0,0,1,446.48,37.1Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.64,41.38c.07-.46.45-.62.9-.36L474.07,61a1.78,1.78,0,0,1,.65.68l6.92-4A1.77,1.77,0,0,0,481,57L446.48,37.1a2,2,0,0,0-1.82,0L439.54,40A2,2,0,0,0,438.64,41.38Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.68,106l3.82-8.59,14.54,8.4c.5.29.91,0,.91-.53l0-42.77a2,2,0,0,0-.9-1.57L439.54,41c-.5-.29-.91-.06-.91.52l0,42.77a2,2,0,0,0,.9,1.58l10.08,5.81,4.19,14.19A1,1,0,0,0,455.68,106Z",
    style: {
      fill: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.68,106l3.82-8.59,14.54,8.4c.5.29.91,0,.91-.53l0-42.77a2,2,0,0,0-.9-1.57L439.54,41c-.5-.29-.91-.06-.91.52l0,42.77a2,2,0,0,0,.9,1.58l10.08,5.81,4.19,14.19A1,1,0,0,0,455.68,106Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M463.33,72.47l-1.21-.7V66.48c0-3.92-2.39-8.49-5.34-10.19s-5.33.11-5.33,4v5.29l-1.21-.7c-1.07-.62-1.93,0-1.93,1.45V80.93a4.73,4.73,0,0,0,.42,1.84,4.58,4.58,0,0,0,1.07,1.52,35.68,35.68,0,0,0,14,8.06c.87.23,1.49-.44,1.49-1.64V76.14A4.59,4.59,0,0,0,463.33,72.47Zm-9.69-10.88c0-2.32,1.41-3.38,3.14-2.38a7.53,7.53,0,0,1,3.15,6V70.5l-6.29-3.63Zm8.2,14.6-6.49,7.56a1.18,1.18,0,0,1-.88.4h-.15a1.16,1.16,0,0,1-.9-.66l-1.86-3.92a1.16,1.16,0,0,1,2.1-1l1.1,2.31,5.32-6.2a1.17,1.17,0,0,1,1.64-.12A1.15,1.15,0,0,1,461.84,76.19Z",
    style: {
      fill: "#fafafa"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/privacy-policy.8724cbc776487160a3589bbd665ce870.svg";
export { ForwardRef as ReactComponent };